// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-11-03T22:56:56.669Z
// Property: Stonebriar Apartment Homes (ID: 6767906449167613)
// Collections: 27 amenities, 5 floorplans (live), 34 photos, 66 POIs, 4 reviews, 5 virtual tours, 6 office hours, 16 faqs
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162465",
  "multihub_property_id": "6767906449167613",
  "property_external_id": "1124193",
  "property_zillow_url": null,
  "property_apartments_url": "https://www.apartments.com/stonebriar-apartment-homes-overland-park-ks/rweczx2/",
  "property_google_business_url": "https://www.google.com/maps/place/Stonebriar+Apartment+Homes/@38.9025448,-94.7253203,890m/data=!3m2!1e3!4b1!4m6!3m5!1s0x87c0eaad8efb2099:0xda1d39faa23da3f7!8m2!3d38.9025448!4d-94.7253203!16s%2Fg%2F1th87n6x?entry=ttu&g_ep=EgoyMDI2MDkxNi4wIKXMDSoASAFQAw%3D%3D",
  "property_linkedin_url": null,
  "property_hubspot_id": null,
  "property_crm_software": "RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": "1124193 p1099145",
  "property_status": null,
  "property_slug": "stonebriar-apartment-homes",
  "property_name": "Stonebriar Apartment Homes",
  "property_website_url": "https://www.stonebriarkc.com/",
  "property_domain": "https://www.stonebriarkc.com/",
  "property_address": "12490 Quivira Rd",
  "property_full_address": "12490 Quivira Rd, Overland Park, KS 66213",
  "property_address_1": "12490 Quivira Rd",
  "property_address_2": null,
  "property_address_city": "Overland Park",
  "property_address_state": "KS",
  "property_address_zip_full": null,
  "property_address_zip": "66213",
  "property_address_country": "US",
  "property_address_county": "Johnson County",
  "property_neighborhood_address": "Outlying Johnson County KS",
  "property_address_latitude": "38.9030792",
  "property_address_longitude": "-94.72484260000002",
  "property_email": "rentcafe.sb@pricekc.com",
  "property_phone": "(913) 513-4673",
  "property_call_tracking_phone": "913-513-4673",
  "property_company_name": "Price Brothers",
  "property_company_url": "https://www.pricebrotherskc.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "<p><strong>Polished comfort in Overland Park.</strong> Stonebriar Apartment Homes pairs spacious one-, two-, and three-bedroom <a href=\"/floor-plans\">floor plans</a> with in-home laundry, private outdoor space, and relaxed community perks—then keeps I-435 and I-35 within easy reach. <a href=\"/schedule-a-tour\">Schedule your tour</a> today.</p>",
  "property_long_description": "<p>Stonebriar Apartment Homes is a park-like apartment community at 12490 Quivira Road in Overland Park, KS, next to the KU Edwards Campus and a quiet place to come back to at the end of the day. The community is managed by Price Brothers Management, a Kansas City family-owned company since 1922.</p><p>Every one-, two-, and three-bedroom apartment has an all-electric kitchen with a dishwasher, an in-home washer and dryer, and a private patio or balcony for morning coffee. Select homes add vaulted ceilings, plank flooring, stainless steel appliances, or a wood-burning fireplace for cooler Kansas evenings.</p><p>Outside your door, two pools are ready for summer afternoons, the 24-hour fitness center fits any schedule, and your dog has an on-site off-leash park. Compare our floor plans, explore our amenities, or schedule a tour and walk the grounds yourself.</p>",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167613/01a0b665-8bb3-7726-a101-9e588d346b22.webp",
  "property_featured_image_media": {
    "alt_text": "Living room with couch, coffee table, and TV.",
    "public_id": "01a0b665-8bb3-7726-a101-9e588d346b22",
    "storage_key": "property/6767906449167613/01a0b665-8bb3-7726-a101-9e588d346b22.webp",
    "width": 3000,
    "height": 2000
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "424",
  "property_year_built": "1993",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "95.51886792452831",
  "property_admin_fee": null,
  "property_application_fee": null,
  "property_fees_deposit_info": "Deposit: $175-375",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "300",
  "property_pet_deposit": "0",
  "property_monthly_pet_rent": "25",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "0",
  "property_pet_restrictions": "Restrictions: Aggressive dog breeds including, but not limited to, Pit Bull, American Staffordshire Terrier, Rottweiler, German Shepherd, Malamute, Doberman Pinscher, Chow, Great Dane, Saint Bernard, Akita, Wolf Hybrid, and any mixed breed that includes the aforementioned, are specifically prohibited and Landlord has discretion to limit other breeds. Inherently dangerous or exotic, feral or wild animals are prohibited.",
  "property_pet_policy_description": "The non-refundable fee is $300 for 1 pet, and $500 for 2 pets.",
  "property_petpolicy_info": "https://www.pricebrotherskc.com/petroyaltyclub/",
  "property_online_leasing_url": "https://stonebriarkc.securecafeapplicant.com/onlineleasing/content3/access/stonebriar0/floorplans",
  "property_resident_portal_url": "https://stonebriarkc.securecafe.com/residentservices/stonebriar0/userlogin.aspx",
  "property_apply_now_url": "https://stonebriarkc.securecafeapplicant.com/onlineleasing/content3/access/stonebriar0/login",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167613/019fc988-fd32-7000-9d64-6387150d00f0.webp",
  "property_primary_logo_media": {
    "alt_text": "Stonebriar Apartment Homes logo",
    "public_id": "019fc988-fd32-7000-9d64-6387150d00f0",
    "storage_key": "property/6767906449167613/019fc988-fd32-7000-9d64-6387150d00f0.webp",
    "width": 2738,
    "height": 600
  },
  "property_secondary_logo": null,
  "property_secondary_logo_media": null,
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167613/01a1a1d5-b324-71cd-958f-f158c4bf4507.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Stonebriar Apartment Homes logo",
    "public_id": "01a1a1d5-b324-71cd-958f-f158c4bf4507",
    "storage_key": "property/6767906449167613/01a1a1d5-b324-71cd-958f-f158c4bf4507.webp",
    "width": 1538,
    "height": 338
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167613/01a0c4f6-866d-7112-864e-6ce543875165.webp",
  "property_mono_black_logo_media": {
    "alt_text": null,
    "public_id": "01a0c4f6-866d-7112-864e-6ce543875165",
    "storage_key": "property/6767906449167613/01a0c4f6-866d-7112-864e-6ce543875165.webp",
    "width": 1280,
    "height": 280
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162465/01a0d9b7-62d2-753a-a137-bd690ff6733b.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162465/019ff682-589f-76db-bc7c-d7916fa7e182.webp",
  "property_company_logo_media": null,
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162465/019ff68a-de80-741a-9687-3e84c8c517e3.webp",
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162465/019ff682-589f-76db-bc7c-d7916fa7e182.webp",
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#54585A",
  "property_secondary_color": "#154734",
  "property_font_color": null,
  "property_color_4": "#50A684",
  "property_color_3": "#4F758B",
  "property_color_5": "#80DED9",
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 3",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "704 - 1308",
  "property_sqft_min": "704",
  "property_sqft_max": "1308",
  "property_price_range": "1276 - 4909",
  "property_price_min": "1276",
  "property_price_max": "4909",
  "property_available_units": 19,
  "property_facebook_url": "https://www.facebook.com/StonebriarKC",
  "property_instagram_url": "https://www.instagram.com/stonebriarkc/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJmSD7jq3qwIcR96M9ovo5Hdo",
  "property_youtube_url": "https://www.youtube.com/user/Pricebrothersmgt",
  "property_yelp_url": null,
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Stonebriar Apartment Homes",
  "property_home_romance_title": "Embrace Your Dream Life in Our Charming Apartment Community",
  "property_home_amenities_blurb": "<p>Stonebriar Apartment Homes balances relaxing outdoor space with conveniences that make everyday life easier. Cool off in one of two pools, keep your routine going at the 24-hour fitness center, or catch up with friends at the clubhouse, which has Wi-Fi, copy, and fax services. When you need to focus, the 24-hour business center is open whenever you are. The car detail center keeps weekend chores close to home, and covered parking and detached garages are available. See the full list of community and apartment amenities.</p>",
  "property_home_floorplans_blurb": "<p><strong>Layouts with room to choose.</strong> Explore one-, two-, and three-bedroom apartments in Overland Park, from efficient one-bedroom designs to the three-bedroom Pinehurst. Everyday ease comes built in with an all-electric kitchen, dishwasher, in-home washer and dryer, extra storage, and a private patio or balcony. Select homes add vaulted ceilings, plank flooring, stainless steel appliances, or a wood-burning fireplace.</p>",
  "property_home_gallery_blurb": "<p>Take a closer look inside at Overland Park apartment homes. Then head outside to the pools, the fitness center, and the park-like grounds. Browse the photo gallery for a preview of your next home.</p>",
  "property_home_neighborhood_blurb": "<p>Stonebriar Apartment Homes sits on Quivira Road next to the KU Edwards Campus, with I-435 and I-35 close by for getting around the metro. Town Center Plaza and Oak Park Mall are a short drive for errands or a Saturday out. Visit our neighborhood page to see what else is close to home.</p>",
  "property_home_reviews_blurb": "<p><strong>Stonebriar earns praise for everyday ease.</strong> Residents point to a quiet, clean setting, well-kept grounds, friendly office staff, and maintenance that’s handled quickly and thoroughly. Reviews also highlight comfortable layouts, thoughtful apartment features, convenient amenities, and strong Overland Park value. Read the latest feedback to see what makes Stonebriar feel comfortable and convenient in all the right ways.</p>",
  "property_neighborhood_blurb": "<p>Stonebriar Apartment Homes is located at 12490 Quivira Road in Overland Park, KS, right next to the University of Kansas Edwards Campus, with Johnson County Community College a short drive north. Black &amp; Veatch, Garmin, Honeywell, Overland Park Regional Medical Center, and Saint Luke’s South Hospital are all within an easy commute, and I-435 and I-35 connect you to the rest of the Kansas City metro.</p><p>Looking for a place to eat near Stonebriar? Our team recommends Club 27 Restaurant, Coach’s Bar &amp; Grill, Desi Bites for Indian food, and Red Robin for an easy family dinner. Fareway Meat Market is a local favorite for fresh cuts. For a later night, there’s Maloney’s Irish Pub or live music at Kanza Hall.</p><p>Town Center Plaza and Oak Park Mall are close by for shopping. For time outdoors, play a round at Sykes/Lady Overland Park Golf Course or spend the afternoon at Thomas S. Stoll Memorial Park.</p><p>Explore our floor plans and amenities, or contact us to set up a visit.</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p>Stonebriar Apartment Homes pairs relaxing community spaces with the details that make daily life easier. Swim laps or spend a summer afternoon at one of two pools. Train at the 24-hour fitness center before work or after dinner, or get things done at the 24-hour business center when home gets busy. The clubhouse has Wi-Fi, copy, and fax services. The car detail center, covered parking, and detached garages take care of your car. High-speed internet access and flexible rent payment options keep the practical side simple. When you want a longer walk or ride, the Indian Creek Trail is nearby.</p><p>Want to see the pools, fitness center, and dog park for yourself? Schedule a tour of Stonebriar Apartment Homes.</p>",
  "property_applynow_blurb": "<p><strong>Ready to call Stonebriar home?</strong> Start your online application for polished Overland Park comfort, with one-, two-, and three-bedroom floor plans, in-home laundry, private outdoor space, generous storage, and access to relaxing community spaces—all in a connected setting near 119th and Quivira.</p>",
  "property_contactus_blurb": "<p>Have questions about floor plans, pricing, availability, amenities, or pet information? Our leasing team at Stonebriar Apartment Homes is happy to help. Call us, stop by the leasing office, or fill out the contact form above.</p>",
  "property_faqs_blurb": "<p>Find answers to common questions about applications, lease terms, deposits, pets, utilities, renters insurance, parking, and maintenance requests at Stonebriar Apartment Homes in Overland Park, KS.</p><p>Still have a question? Contact us and our leasing team will be glad to help.</p>",
  "property_floorplans_blurb": "<p>Stonebriar Apartment Homes offers five floor plans from 704 to 1,308 square feet, each named for a famous golf course. The one-bedroom, one-bath plans are the Muirfield (704 sq. ft.) and the Pebble Beach (763 sq. ft.). The two-bedroom plans are the St. Andrews, with one bath (936 sq. ft.), and the Augusta, with two baths (1,022 sq. ft.). The Pinehurst is the three-bedroom, two-bath layout at 1,308 square feet.</p><p>Every Stonebriar apartment includes an all-electric kitchen with a dishwasher, an in-home washer and dryer, and a private patio or balcony. Select homes add vaulted ceilings, plank flooring, stainless steel appliances, or a wood-burning fireplace.</p><p>Compare pricing and availability above or take a virtual tour.</p>",
  "property_gallery_blurb": "<p>Get a feel for Stonebriar Apartment Homes in Overland Park, KS, before you visit. The outdoor photos cover the park-like grounds, both pools, the 24-hour fitness center, the business center, and the car detail center. You’ll also see covered parking, the detached garages, and the off-leash dog park.</p><p>Inside, see our modern kitchens, living areas, extra storage, and private patios or balconies. Like what you see? Compare our floor plans or schedule a tour and picture yourself at Stonebriar Apartment Homes.</p>",
  "property_interactivemap_blurb": "<p>Find your spot at Stonebriar Apartment Homes before you set foot on site. Our interactive property map lets you explore available apartments by building, floor plan, and location within the community.</p><p>Filter by bedroom count, then select an apartment to see its square footage, features, and availability. For more details, review our full list of floor plans and amenities.</p>",
  "property_pets_blurb": "<p>Stonebriar Apartment Homes welcomes dogs and cats, up to two pets per apartment home. The off-leash dog park gives them room to run.</p><p>Monthly pet rent: $25 per pet</p><p>Non-refundable pet fee: $300 for one pet or $500 for two pets</p><p>Breed Restrictions: Restricted breeds include Pit Bull, American Staffordshire Terrier, Rottweiler, German Shepherd, Malamute, Doberman Pinscher, Chow, Great Dane, Saint Bernard, Akita, Wolf Hybrid, and mixes containing any of these breeds. Management may restrict additional breeds. Exotic, feral, wild, or inherently dangerous animals are not permitted.</p><p>When you pay the one-time pet fee, you’re enrolled in the <a href=\"https://www.pricebrotherskc.com/petroyaltyclub/\" target=\"_blank\">Price Brothers Pet Royalty Club</a>. Learn more about the program perks on the <a href=\"https://www.pricebrotherskc.com/petroyaltyclub/\" target=\"_blank\">Price Brothers Management website</a>.</p>",
  "property_referafriend_blurb": "<p><strong>Love life at Stonebriar?</strong> Share the polished comfort, connected Overland Park setting, and easy everyday perks with a friend. From spacious floor plans to relaxing community spaces, there’s plenty to recommend—send an invite and let them see why Stonebriar feels like a smart place to call home.</p>",
  "property_residentaccess_blurb": "<p><strong>Resident Access at Stonebriar Apartment Homes</strong><br>Keep your Overland Park routine simple. Log in to pay rent, submit maintenance requests, and manage your account from one convenient place—so you can get back to enjoying the polished comfort of home near 119th and Quivira.</p>",
  "property_reviews_blurb": "<p><strong>See why residents recommend Stonebriar Apartment Homes.</strong> Reviews consistently highlight the details that make daily living feel easy: a quiet, clean setting, well-kept grounds, friendly office staff, and maintenance requests handled quickly and thoroughly.</p><p>Residents also call out thoughtful apartment features, comfortable layouts, community amenities, and strong value in Overland Park. One reviewer summed it up as “Everything you would want for comfort and convenience all in one place.” Browse the latest ratings and feedback to hear directly from people who have called Stonebriar home.</p>",
  "property_created_at": "1785792570149",
  "property_scheduletour_blurb": "<p>Come see Stonebriar Apartment Homes in person. Walk through our one-, two-, and three-bedroom floor plans, check out the community amenities, and get a feel for our Overland Park apartments. Choose a date and time above to book a guided tour with our leasing team, or take a self-guided tour whenever it fits your schedule.</p>",
  "property_thankyou_blurb": "<p><strong>Thank you — we’ve received your inquiry.</strong><br>Stonebriar Apartment Homes’ leasing team will be in touch soon. In the meantime, picture polished Overland Park comfort with spacious floor plans, in-home laundry, private outdoor space, and easy access to pools, fitness, and everyday conveniences near 119th and Quivira.</p>",
  "property_virtualtours_blurb": "<p>Explore Stonebriar Apartment Homes online before you visit. Our virtual tours let you move through select layouts at your own pace. You can see how the kitchen, living rooms, and bedrooms fit together to make your perfect home. Check square footage and availability on our floor plans page, or schedule a tour when you’re ready to see Stonebriar in person.</p>",
  "property_copyright": "2026 All Rights Reserved. Stonebriar Apartment Homes",
  "property_seo_title_home": "Overland Park Apartments | Stonebriar Apartment Homes",
  "property_seo_description_home": "Stonebriar Apartment Homes offers 1, 2 & 3-bedroom apartments in Overland Park, KS with two pools, a 24-hour gym, and in-home laundry. Tour today!",
  "property_seo_title_floorplans": "1, 2 & 3-Bedroom Apartments in Overland Park, KS",
  "property_seo_description_floorplans": "Compare five floor plans at Stonebriar Apartment Homes, from 704 to 1,308 sq. ft., each with an all-electric kitchen and a private patio or balcony.",
  "property_seo_title_amenities": "Pet-Friendly Apartments in Overland Park, KS",
  "property_seo_description_amenities": "Stonebriar Apartment Homes offers pet-friendly living in Overland Park, KS with an off-leash dog park, two pools, and detached garages available.",
  "property_seo_title_gallery": "Photos | Stonebriar Apartment Homes in Overland Park",
  "property_seo_description_gallery": "Browse photos of Stonebriar Apartment Homes in Overland Park, KS, including apartment interiors, two swimming pools, and the 24-hour fitness center.",
  "property_seo_title_virtualtours": "Apartment Virtual Tours in Overland Park, KS",
  "property_seo_description_virtualtours": "Take a virtual tour of 1, 2 & 3-bedroom apartments at Stonebriar Apartment Homes in Overland Park, KS before you schedule an in-person visit.",
  "property_seo_title_interactivemap": "Interactive Map | Stonebriar Apartment Homes",
  "property_seo_description_interactivemap": "Use the interactive property map at Stonebriar Apartment Homes to find available apartments by building and floor plan in Overland Park, KS.",
  "property_seo_title_neighborhood": "Apartments Near JCCC in Overland Park, KS",
  "property_seo_description_neighborhood": "Stonebriar Apartment Homes is near Johnson County Community College, Oak Park Mall, Indian Creek Trail, and I-435 in Overland Park, KS.",
  "property_seo_title_contact": "Contact Stonebriar Apartment Homes | Overland Park",
  "property_seo_description_contact": "Contact Stonebriar Apartment Homes at 12490 Quivira Rd in Overland Park, KS with questions about floor plans, pricing, availability, or tours.",
  "property_seo_title_faqs": "FAQs | Stonebriar Apartment Homes in Overland Park",
  "property_seo_description_faqs": "Find answers about applications, pets, utilities, renters insurance, and maintenance at Stonebriar Apartment Homes in Overland Park, KS.",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Overland Park, KS",
  "property_seo_description_reviews": "Discover life at Stonebriar Apartments in Overland Park, KS! Enjoy amenities like a pool, fitness center, and pet-friendly spaces!",
  "property_seo_title_applynow": "Apply Now | Apartments in Overland Park, KS",
  "property_seo_description_applynow": "Elevate your lifestyle at Stonebriar Apartment Homes in Overland Park! With modern amenities, spacious floor plans, and online leasing, your dream home awaits.",
  "property_seo_title_residentaccess": "Resident Access | Stonebriar Apartment Homes",
  "property_seo_description_residentaccess": "Elevate your living at Stonebriar Apartment Homes! Log in to your resident portal for easy rent payments, maintenance requests, and community updates.",
  "property_seo_title_referafriend": "Refer A Friend | Stonebriar Apartment Homes",
  "property_seo_description_referafriend": "Great friends make great neighbors! Refer a friend to Stonebriar Apartment Homes in Overland Park, KS, and enjoy a vibrant community together!",
  "property_seo_title_scheduletour": "Schedule a Tour | Stonebriar Apartment Homes",
  "property_seo_description_scheduletour": "Book a guided or self-guided tour of Stonebriar Apartment Homes at 119th and Quivira in Overland Park, KS. Choose a date and time that works for you.",
  "property_seo_title_privacy": "Privacy Policy | Stonebriar Apartment Homes",
  "property_seo_description_privacy": "At Stonebriar Apartment Homes in Overland Park, KS, your privacy matters. Learn how we protect your information in our comprehensive privacy policy.",
  "property_seo_title_accessibility": "Website Accessibility | Stonebriar Apartment Homes",
  "property_seo_description_accessibility": "At Stonebriar Apartments in Overland Park, we prioritize digital accessibility for all. Join our inclusive community where everyone is welcomed and valued.",
  "property_seo_title_sitemap": "Sitemap | Stonebriar Apartment Homes",
  "property_seo_description_sitemap": "Navigate your way to luxury living at Stonebriar Apartment Homes in Overland Park, KS. Check out our sitemap for a clear path to your new home!",
  "property_seo_title_thankyou": "Thank You | Stonebriar Apartment Homes",
  "property_seo_description_thankyou": "Thank you for your interest in Stonebriar Apartment Homes! Your inquiry is received—expect a team member to reach out soon about your new Overland Park home.",
  "property_seo_title_pets": "Pet Policy | Apartments in Overland Park, KS",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1793742990329",
  "amenities": [
    {
      "id": "ec_adab6c70f2fafeedea41fca0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167613",
      "source": "yardi",
      "external_id": "88125877",
      "title": "Covered Parking & Detached Garages Available",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167613/01a0b665-9f53-715e-b55a-4df2baf1ff6e.webp",
      "amenity_image_media": {
        "alt_text": "Garage building with multiple bays and covered parking area adjacent.",
        "public_id": "01a0b665-9f53-715e-b55a-4df2baf1ff6e",
        "storage_key": "property/6767906449167613/01a0b665-9f53-715e-b55a-4df2baf1ff6e.webp",
        "width": 1200,
        "height": 800
      },
      "amenity_image_alt_text": "Row of detached garages at Stonebriar Apartments community in Overland Park KS,Covered carports with parking spaces at Stonebriar Apartments in Overland Park, Kansas",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a011fd38d8f2e993bd383d7e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167613",
      "source": "yardi",
      "external_id": "88125891",
      "title": "Two Shimmering Swimming Pools",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167613/01a0b665-a010-75b6-acc1-32cb0b11115a.webp",
      "amenity_image_media": {
        "alt_text": "Resort-style pool with fountain and lounge chairs, surrounded by lush greenery and apartment buildings.",
        "public_id": "01a0b665-a010-75b6-acc1-32cb0b11115a",
        "storage_key": "property/6767906449167613/01a0b665-a010-75b6-acc1-32cb0b11115a.webp",
        "width": 1200,
        "height": 800
      },
      "amenity_image_alt_text": "A pool area with a fountain and a patio umbrella.,A blue couch and chair set is on a patio.,A large swimming pool surrounded by a fence and chairs.,A large swimming pool surrounded by lounge chairs and trees.,An aerial view of a swimming pool surrounded by trees and lawn chairs.,A large apartment complex with a pool and waterfall.",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7311fac21b819f6353faa485",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167613",
      "source": "yardi",
      "external_id": "88125878",
      "title": "24-Hour Fitness Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167613/01a0b665-c16b-75fc-a6d2-36fccd425a29.webp",
      "amenity_image_media": {
        "alt_text": "Treadmills, stationary bikes, and weight machines in a well-equipped fitness center.",
        "public_id": "01a0b665-c16b-75fc-a6d2-36fccd425a29",
        "storage_key": "property/6767906449167613/01a0b665-c16b-75fc-a6d2-36fccd425a29.webp",
        "width": 3072,
        "height": 2048
      },
      "amenity_image_alt_text": "A gym with treadmills, weights, and exercise equipment.,A fitness center with treadmills and other fitness equipment at Stonebriar Apartments in Overland Park, KS.",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4346547d1f13023f3f0d9d69",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167613",
      "source": "yardi",
      "external_id": "88125875",
      "title": "24-Hour Business Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167613/01a0b665-bca0-74fc-ba85-6dfd0af83c89.webp",
      "amenity_image_media": {
        "alt_text": "Business center with computers and a round table with chairs.",
        "public_id": "01a0b665-bca0-74fc-ba85-6dfd0af83c89",
        "storage_key": "property/6767906449167613/01a0b665-bca0-74fc-ba85-6dfd0af83c89.webp",
        "width": 3072,
        "height": 2048
      },
      "amenity_image_alt_text": "The business center with two computers and a printer at Stonebriar Woods Apartments in Overland Park, KS",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_37546de3e2c033baf3deb809",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167613",
      "source": "yardi",
      "external_id": "88125876",
      "title": "Clubhouse with Wi-Fi, Copy & Fax Service",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167613/01a0b665-a012-75e6-ba4f-3acca2ef3a7b.webp",
      "amenity_image_media": {
        "alt_text": "Front entrance of a multifamily property with a leasing center sign, columns, and colorful flower beds.",
        "public_id": "01a0b665-a012-75e6-ba4f-3acca2ef3a7b",
        "storage_key": "property/6767906449167613/01a0b665-a012-75e6-ba4f-3acca2ef3a7b.webp",
        "width": 1200,
        "height": 800
      },
      "amenity_image_alt_text": "The clubhouse and leasing office with a gorgeous flower bed at Stonebriar Apartments in Overland Park, KS.",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3b74309e3ec72a6c5864cb42",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167613",
      "source": "yardi",
      "external_id": "88125879",
      "title": "High Speed Internet Access",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a5de4b6a18e9cfcf101e99ec",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167613",
      "source": "yardi",
      "external_id": "88125880",
      "title": "On-Call Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_aba49d8c249e2f32411ed706",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167613",
      "source": "yardi",
      "external_id": "88125890",
      "title": "Off-Leash Dog Park",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4eab3ab4f633c6d8062c43cd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167613",
      "source": "yardi",
      "external_id": "88125885",
      "title": "Car Detail Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167613/01a0b665-c798-7706-9ebe-7837b4bd9bf8.webp",
      "amenity_image_media": {
        "alt_text": "Exterior view of apartment building with multiple doors and covered porch.",
        "public_id": "01a0b665-c798-7706-9ebe-7837b4bd9bf8",
        "storage_key": "property/6767906449167613/01a0b665-c798-7706-9ebe-7837b4bd9bf8.webp",
        "width": 1200,
        "height": 800
      },
      "amenity_image_alt_text": "Car wash station building and drive-up area at Stonebriar Apartments Overland Park Kansas,Covered car wash bay with hose hookup at Stonebriar Apartments in Overland Park,Exterior car wash station with vacuum and hose at Stonebriar Apartments in Overland Park KS",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_139cc8b4f7324e3a32a965be",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167613",
      "source": "yardi",
      "external_id": "88125883",
      "title": "Easy Access to Freeways & Shopping",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a12ba7c63d7a349ff1dcddcd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167613",
      "source": "yardi",
      "external_id": "88125889",
      "title": "Near Access to Indian Creek Trail",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167613/01a0b665-e40c-750c-b13a-fde8095c9b9f.webp",
      "amenity_image_media": {
        "alt_text": "Couple running on a path in a lush green park with sunlight filtering through the trees.",
        "public_id": "01a0b665-e40c-750c-b13a-fde8095c9b9f",
        "storage_key": "property/6767906449167613/01a0b665-e40c-750c-b13a-fde8095c9b9f.webp",
        "width": 3072,
        "height": 2050
      },
      "amenity_image_alt_text": "a couple jogging in a park at Stonebriar Apartments, Kansas, 66213",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ff4cbf4023b45cd6e1e3f698",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167613",
      "source": "yardi",
      "external_id": "120549883",
      "title": "Smoke-Free Community",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9ed057ae75643e840a631668",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167613",
      "source": "yardi",
      "external_id": "120967423",
      "title": "Price Brothers Pet Royalty Club Program",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167613/01a0b665-b120-708b-bb53-0aa6f56de2e9.webp",
      "amenity_image_media": {
        "alt_text": "A person walking their dog on a sidewalk.",
        "public_id": "01a0b665-b120-708b-bb53-0aa6f56de2e9",
        "storage_key": "property/6767906449167613/01a0b665-b120-708b-bb53-0aa6f56de2e9.webp",
        "width": 3072,
        "height": 2050
      },
      "amenity_image_alt_text": "Price Brothers Pet Royalty Club Program at Stonebriar Apartments, Kansas",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_221cb2d258edccc4884d2f18",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167613",
      "source": "yardi",
      "external_id": "122755397",
      "title": "Flexible Rent Payment Options Available",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7c0aee3e1bc874387d517415",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167613",
      "source": "yardi",
      "external_id": "88125899",
      "title": "Washer & Dryer In Unit",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167613/01a0b665-d737-77a8-8c1f-8574d898a534.webp",
      "amenity_image_media": {
        "alt_text": "Washer and dryer in laundry room with storage shelves and electrical panel.",
        "public_id": "01a0b665-d737-77a8-8c1f-8574d898a534",
        "storage_key": "property/6767906449167613/01a0b665-d737-77a8-8c1f-8574d898a534.webp",
        "width": 1200,
        "height": 800
      },
      "amenity_image_alt_text": "Laundry closet with washer and dryer inside Stonebriar Apartments unit,In-unit laundry area with dryer and shelving at Stonebriar Apartments in Overland Park Kansas",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f66a3317f5112d1554a43c86",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167613",
      "source": "yardi",
      "external_id": "88125894",
      "title": "Dishwasher",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167613/01a0b665-de48-774b-a6c6-7fede518eb0e.webp",
      "amenity_image_media": {
        "alt_text": "Modern kitchen with white cabinets, granite countertops, and stainless steel appliances.",
        "public_id": "01a0b665-de48-774b-a6c6-7fede518eb0e",
        "storage_key": "property/6767906449167613/01a0b665-de48-774b-a6c6-7fede518eb0e.webp",
        "width": 3000,
        "height": 2000
      },
      "amenity_image_alt_text": "All-Electric Kitchen at Stonebriar Apartments, Overland Park, KS, 66213",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f9e3dd60a0488a11fa72772d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167613",
      "source": "yardi",
      "external_id": "88125896",
      "title": "Wood Burning Fireplace*",
      "amount": "false",
      "description": "*in Select Homes",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167613/01a0b665-f8ba-777c-ad90-f4eca6b34aad.webp",
      "amenity_image_media": {
        "alt_text": "Spacious living room with vaulted ceilings, fireplace, and a sectional sofa.",
        "public_id": "01a0b665-f8ba-777c-ad90-f4eca6b34aad",
        "storage_key": "property/6767906449167613/01a0b665-f8ba-777c-ad90-f4eca6b34aad.webp",
        "width": 1200,
        "height": 800
      },
      "amenity_image_alt_text": "Bright living room with fireplace and high ceiling at Stonebriar Apartments Overland Park KS,Living room with fireplace, vaulted ceiling, and large windows at Stonebriar Apartments",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_cc5d7dcd7b053bb3e34c93a8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167613",
      "source": "yardi",
      "external_id": "88125895",
      "title": "Extra Storage",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_56388310189091e704f6ec3e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167613",
      "source": "yardi",
      "external_id": "88125898",
      "title": "Patio or Balcony",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167613/01a0b665-fc3c-749f-9ff7-97602763750d.webp",
      "amenity_image_media": {
        "alt_text": "Balcony view with a door and windows.",
        "public_id": "01a0b665-fc3c-749f-9ff7-97602763750d",
        "storage_key": "property/6767906449167613/01a0b665-fc3c-749f-9ff7-97602763750d.webp",
        "width": 3072,
        "height": 2049
      },
      "amenity_image_alt_text": "A private balcony with white railing, large windows, and a green door.,Private, fenced-in patio and balcony on a brick apartment building, overlooking a grassy area at Stonebriar Apartments.",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_67b086b8b3c30b0e3a0962a8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167613",
      "source": "yardi",
      "external_id": "88125893",
      "title": "Ceiling Fan(s)*",
      "amount": "false",
      "description": "*in Select Homes",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167613/01a0b665-f421-75bd-88e4-90702e1e7fe8.webp",
      "amenity_image_media": {
        "alt_text": "Bedroom with ceiling fan, dresser with artwork, and walk-in closet.",
        "public_id": "01a0b665-f421-75bd-88e4-90702e1e7fe8",
        "storage_key": "property/6767906449167613/01a0b665-f421-75bd-88e4-90702e1e7fe8.webp",
        "width": 3000,
        "height": 2000
      },
      "amenity_image_alt_text": "a bedroom with a large bed and a ceiling fanat Stonebriar Apartments, Overland Park",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_02783f3b2cd54c8bedb90442",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167613",
      "source": "yardi",
      "external_id": "88125897",
      "title": "Vaulted Ceilings*",
      "amount": "false",
      "description": "*in Select Homes",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0a86809ef9062b8307b95366",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167613",
      "source": "yardi",
      "external_id": "120967399",
      "title": "Cable Ready",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_45319f3694877ec0d1bb8632",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167613",
      "source": "yardi",
      "external_id": "88125900",
      "title": "All-Electric Kitchen",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167613/01a0b665-de48-774b-a6c6-7fede518eb0e.webp",
      "amenity_image_media": {
        "alt_text": "Modern kitchen with white cabinets, granite countertops, and stainless steel appliances.",
        "public_id": "01a0b665-de48-774b-a6c6-7fede518eb0e",
        "storage_key": "property/6767906449167613/01a0b665-de48-774b-a6c6-7fede518eb0e.webp",
        "width": 3000,
        "height": 2000
      },
      "amenity_image_alt_text": "a kitchen with white appliances and wooden cabinetsat Stonebriar Apartments, Kansas, 66213",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e0b399275cdd21d6059b3eb4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167613",
      "source": "yardi",
      "external_id": "122010768",
      "title": "Stainless Steel Appliances*",
      "amount": "false",
      "description": "*in Select Homes",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_01ed127e7df2fc66262de3e8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167613",
      "source": "yardi",
      "external_id": "88146748",
      "title": "Black Appliances*",
      "amount": "false",
      "description": "*in Select Homes",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167613/01a0b665-f54d-776b-9ed3-ecfef16e3589.webp",
      "amenity_image_media": {
        "alt_text": "Kitchen with black appliances, double sink, and wood floors",
        "public_id": "01a0b665-f54d-776b-9ed3-ecfef16e3589",
        "storage_key": "property/6767906449167613/01a0b665-f54d-776b-9ed3-ecfef16e3589.webp",
        "width": 1200,
        "height": 800
      },
      "amenity_image_alt_text": "Galley-style kitchen with wood cabinets and black appliances at Stonebriar Apartments Overland Park,Apartment kitchen with black appliances, double sink, and open dining area at Stonebriar Apartments",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_38b6f0c5c034d19aac4494de",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167613",
      "source": "yardi",
      "external_id": "89952400",
      "title": "Plank Flooring*",
      "amount": "false",
      "description": "*Varying Locations in Select Homes",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167613/01a0b666-0871-728a-99a7-07d2201790cd.webp",
      "amenity_image_media": {
        "alt_text": "Kitchen and dining area with wooden cabinets, white appliances, and a glass-top table.",
        "public_id": "01a0b666-0871-728a-99a7-07d2201790cd",
        "storage_key": "property/6767906449167613/01a0b666-0871-728a-99a7-07d2201790cd.webp",
        "width": 3000,
        "height": 2000
      },
      "amenity_image_alt_text": "A kitchen and dining room with hardwood floors and white appliances.",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f873ea00769c1383fb05b61c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167613",
      "source": "yardi",
      "external_id": "88125902",
      "title": "Central Air & Heating",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "ec_228c499a2e1f7fb343708d5c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167613",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167613/01a0b665-8bb3-7726-a101-9e588d346b22.webp",
      "image_media": {
        "alt_text": "Living room with couch, coffee table, and TV.",
        "public_id": "01a0b665-8bb3-7726-a101-9e588d346b22",
        "storage_key": "property/6767906449167613/01a0b665-8bb3-7726-a101-9e588d346b22.webp",
        "width": 3000,
        "height": 2000
      },
      "title": "Apartment",
      "description": "Spacious and inviting living room featuring a comfortable sectional sofa, a modern coffee table, and a mounted television, perfect for relaxation and entertainment.",
      "link": "false",
      "alt_text": "Living room with couch, coffee table, and TV.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/12490 quivira rd-1_final.jpg"
    },
    {
      "id": "ec_3907c9be022a1c61cb155f20",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167613",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167613/01a0b666-2938-73d0-817c-a410cd270fec.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen bed, nightstands, and a ceiling fan.",
        "public_id": "01a0b666-2938-73d0-817c-a410cd270fec",
        "storage_key": "property/6767906449167613/01a0b666-2938-73d0-817c-a410cd270fec.webp",
        "width": 3000,
        "height": 2000
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a comfortable queen-size bed, elegantly appointed nightstands with lamps, and a modern ceiling fan for year-round comfort. A large window allows natural light to flood the room.",
      "link": "false",
      "alt_text": "Bedroom with a queen bed, nightstands, and a ceiling fan.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/12490 Quivira Rd-11_final.jpg"
    },
    {
      "id": "ec_6fb7355b6b695457337ecd64",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167613",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167613/01a0b666-2937-7653-8ed1-4931d0877d75.webp",
      "image_media": {
        "alt_text": "Modern kitchen with dark countertops, white cabinets, and stainless steel appliances.",
        "public_id": "01a0b666-2937-7653-8ed1-4931d0877d75",
        "storage_key": "property/6767906449167613/01a0b666-2937-7653-8ed1-4931d0877d75.webp",
        "width": 3000,
        "height": 2000
      },
      "title": "Apartment",
      "description": "A spacious and well-equipped kitchen featuring dark granite countertops, ample cabinet space, a double sink, and a refrigerator. Perfect for preparing meals.",
      "link": "false",
      "alt_text": "Modern kitchen with dark countertops, white cabinets, and stainless steel appliances.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/12490 Quivira Rd-9_final(1).jpg"
    },
    {
      "id": "ec_681b48169d655de42903d225",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167613",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167613/01a0b666-381c-72a8-98f5-633870795a78.webp",
      "image_media": {
        "alt_text": "In-unit washer and dryer with a shelf above, view into kitchen and dining area.",
        "public_id": "01a0b666-381c-72a8-98f5-633870795a78",
        "storage_key": "property/6767906449167613/01a0b666-381c-72a8-98f5-633870795a78.webp",
        "width": 3000,
        "height": 2000
      },
      "title": "Apartment",
      "description": "Convenient in-unit washer and dryer located near the kitchen and dining area for easy access.",
      "link": "false",
      "alt_text": "In-unit washer and dryer with a shelf above, view into kitchen and dining area.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Stonebriar-034_Photo_Apartment-Interior_Staged-Laundry-Room_Dryer_2026-06-15_Original-Size.jpg"
    },
    {
      "id": "ec_86c8971776dafbef9b53eb06",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167613",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167613/01a0b666-1e1a-7649-aee7-028c4ab8509d.webp",
      "image_media": {
        "alt_text": "Interior view of a laundry room with two white top-load washing machines and two shelves.",
        "public_id": "01a0b666-1e1a-7649-aee7-028c4ab8509d",
        "storage_key": "property/6767906449167613/01a0b666-1e1a-7649-aee7-028c4ab8509d.webp",
        "width": 3000,
        "height": 2000
      },
      "title": "Apartment",
      "description": "Convenient in-unit laundry facilities make chores a breeze. This apartment features two top-load washing machines and ample storage space.",
      "link": "false",
      "alt_text": "Interior view of a laundry room with two white top-load washing machines and two shelves.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Stonebriar-034_Photo_Apartment-Interior_Staged-Laundry-Room_Washer-and-Dryer_2026-06-15_Original-Size.jpg"
    },
    {
      "id": "ec_1bdb57e66fd4072eb014248d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167613",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167613/01a0b666-269d-72e4-b1c6-1cfd51edf6c3.webp",
      "image_media": {
        "alt_text": "Living room with a TV, ceiling fan, and a view into the kitchen.",
        "public_id": "01a0b666-269d-72e4-b1c6-1cfd51edf6c3",
        "storage_key": "property/6767906449167613/01a0b666-269d-72e4-b1c6-1cfd51edf6c3.webp",
        "width": 3000,
        "height": 2000
      },
      "title": "Apartment",
      "description": "Spacious living room featuring a ceiling fan, entertainment center with a TV, and an open view to the kitchen area. Perfect for relaxation and entertaining.",
      "link": "false",
      "alt_text": "Living room with a TV, ceiling fan, and a view into the kitchen.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/12490 Quivira Rd-5_final.jpg"
    },
    {
      "id": "ec_456532cdfde62f8ef0c52035",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167613",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167613/01a0b666-31e5-70cb-8ff0-76fffbea5eb3.webp",
      "image_media": {
        "alt_text": "Living room with a sectional sofa, coffee table, and ceiling fan.",
        "public_id": "01a0b666-31e5-70cb-8ff0-76fffbea5eb3",
        "storage_key": "property/6767906449167613/01a0b666-31e5-70cb-8ff0-76fffbea5eb3.webp",
        "width": 3000,
        "height": 2000
      },
      "title": "Apartment",
      "description": "Spacious living area featuring a comfortable sectional sofa, a modern coffee table, and a ceiling fan for added comfort.",
      "link": "false",
      "alt_text": "Living room with a sectional sofa, coffee table, and ceiling fan.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/12490 Quivira Rd-3_final.jpg"
    },
    {
      "id": "ec_3cfed2cec8eead67976a53a8",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167613",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167613/01a0b666-519b-77af-a965-61ed39b1b7fa.webp",
      "image_media": {
        "alt_text": "Living room with a white sectional couch, coffee table, TV, and ceiling fan.",
        "public_id": "01a0b666-519b-77af-a965-61ed39b1b7fa",
        "storage_key": "property/6767906449167613/01a0b666-519b-77af-a965-61ed39b1b7fa.webp",
        "width": 3000,
        "height": 2000
      },
      "title": "Apartment",
      "description": "Spacious living room featuring a comfortable white sectional, a modern coffee table, and a wall-mounted TV, perfect for relaxation and entertainment.",
      "link": "false",
      "alt_text": "Living room with a white sectional couch, coffee table, TV, and ceiling fan.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/12490 Quivira Rd-2_final.jpg"
    },
    {
      "id": "ec_a69d943f15154757cd5e2340",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167613",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167613/01a0b666-53ce-7168-bdc1-a78a62d3891f.webp",
      "image_media": {
        "alt_text": "Modern kitchen and living area with white sectional sofa and abstract art.",
        "public_id": "01a0b666-53ce-7168-bdc1-a78a62d3891f",
        "storage_key": "property/6767906449167613/01a0b666-53ce-7168-bdc1-a78a62d3891f.webp",
        "width": 3000,
        "height": 2000
      },
      "title": "Apartment",
      "description": "Spacious kitchen and living room area with modern appliances, a dining table, and tasteful decor. Perfect for entertaining or relaxing.",
      "link": "false",
      "alt_text": "Modern kitchen and living area with white sectional sofa and abstract art.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/12490 Quivira Rd-8_final.jpg"
    },
    {
      "id": "ec_04bcd0434759834ef8fa1e56",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167613",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167613/01a0b666-6939-73ff-b4aa-1c8fa7fde037.webp",
      "image_media": {
        "alt_text": "Kitchen and dining area with white cabinets, a stove, and a glass-top table.",
        "public_id": "01a0b666-6939-73ff-b4aa-1c8fa7fde037",
        "storage_key": "property/6767906449167613/01a0b666-6939-73ff-b4aa-1c8fa7fde037.webp",
        "width": 3000,
        "height": 2000
      },
      "title": "Apartment",
      "description": "A bright and airy kitchen and dining area featuring white cabinetry, modern appliances, and a comfortable dining space perfect for meals.",
      "link": "false",
      "alt_text": "Kitchen and dining area with white cabinets, a stove, and a glass-top table.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/12490 Quivira Rd-7_final.jpg"
    },
    {
      "id": "ec_65e01f97b11064217772f5d9",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167613",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167613/01a0b666-5baa-77e9-b060-44ca1f3129e5.webp",
      "image_media": {
        "alt_text": "Bedroom with a bed, dresser, and window.",
        "public_id": "01a0b666-5baa-77e9-b060-44ca1f3129e5",
        "storage_key": "property/6767906449167613/01a0b666-5baa-77e9-b060-44ca1f3129e5.webp",
        "width": 3000,
        "height": 2000
      },
      "title": "Apartment",
      "description": "A beautifully staged bedroom featuring a comfortable bed, a modern dresser with decorative items, and a window offering natural light.",
      "link": "false",
      "alt_text": "Bedroom with a bed, dresser, and window.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/12490 Quivira Rd-14_final.jpg"
    },
    {
      "id": "ec_0bbcde21ffeac6aac42c3288",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167613",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167613/01a0b666-593e-73f8-8c68-23c9756ea44b.webp",
      "image_media": {
        "alt_text": "Closet with shelves and hanging clothes.",
        "public_id": "01a0b666-593e-73f8-8c68-23c9756ea44b",
        "storage_key": "property/6767906449167613/01a0b666-593e-73f8-8c68-23c9756ea44b.webp",
        "width": 3000,
        "height": 2000
      },
      "title": "Apartment",
      "description": "Spacious closet with ample shelving and hanging space for your wardrobe.",
      "link": "false",
      "alt_text": "Closet with shelves and hanging clothes.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/12490 Quivira Rd-13_final.jpg"
    },
    {
      "id": "ec_3984f31110fbd7bbd0b2869e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167613",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167613/01a0b666-71e4-743d-ad7c-fd999008d1f7.webp",
      "image_media": {
        "alt_text": "Bathroom vanity with sink, toilet, and bathtub with shower curtain.",
        "public_id": "01a0b666-71e4-743d-ad7c-fd999008d1f7",
        "storage_key": "property/6767906449167613/01a0b666-71e4-743d-ad7c-fd999008d1f7.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "A clean and functional bathroom featuring a vanity with sink, a toilet, and a bathtub with a decorative shower curtain. The space is finished with wood-look flooring.",
      "link": "false",
      "alt_text": "Bathroom vanity with sink, toilet, and bathtub with shower curtain.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/15-12490 Quivira Rd-15_final.jpg"
    },
    {
      "id": "ec_8bbd6be1c7f4c606fdd40ea9",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167613",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167613/01a0b666-7673-74bf-93e4-e68de748c4a3.webp",
      "image_media": {
        "alt_text": "Living room with fireplace, TV, sectional sofa, coffee table, and two armchairs.",
        "public_id": "01a0b666-7673-74bf-93e4-e68de748c4a3",
        "storage_key": "property/6767906449167613/01a0b666-7673-74bf-93e4-e68de748c4a3.webp",
        "width": 3000,
        "height": 2000
      },
      "title": "Apartment",
      "description": "Cozy living room featuring a fireplace, mounted TV, comfortable sectional sofa, and stylish coffee table, perfect for relaxing or entertaining.",
      "link": "false",
      "alt_text": "Living room with fireplace, TV, sectional sofa, coffee table, and two armchairs.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Stonebriar-034_Photo_Apartment-Interior_Staged-Living-Room_Fireplace_Angle-1_2026-06-15_Original-Size.jpg"
    },
    {
      "id": "ec_b4f80680563ab67dadc662b0",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167613",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167613/01a0b666-7e92-77d9-8231-a607ebc91513.webp",
      "image_media": {
        "alt_text": "Spacious living room with vaulted ceiling, fireplace, and sectional sofa.",
        "public_id": "01a0b666-7e92-77d9-8231-a607ebc91513",
        "storage_key": "property/6767906449167613/01a0b666-7e92-77d9-8231-a607ebc91513.webp",
        "width": 3000,
        "height": 2000
      },
      "title": "Apartment",
      "description": "Experience comfort and style in this beautifully appointed living room, featuring a cozy fireplace and ample natural light. Perfect for relaxation and entertaining.",
      "link": "false",
      "alt_text": "Spacious living room with vaulted ceiling, fireplace, and sectional sofa.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Stonebriar-034_Photo_Apartment-Interior_Staged-Living-Room_Fireplace_Angle-2_2026-06-15_Original-Size.jpg"
    },
    {
      "id": "ec_5500e6c5b3283cf63019e321",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167613",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167613/01a0b666-9566-72a7-8c66-9246f7f63d79.webp",
      "image_media": {
        "alt_text": "Kitchen with dark countertops, stainless steel sink, and stove.",
        "public_id": "01a0b666-9566-72a7-8c66-9246f7f63d79",
        "storage_key": "property/6767906449167613/01a0b666-9566-72a7-8c66-9246f7f63d79.webp",
        "width": 3000,
        "height": 2000
      },
      "title": "Apartment",
      "description": "Modern kitchen with ample counter space, featuring a double sink, dishwasher, and a full-size range. The open layout flows into a dining area with plush seating.",
      "link": "false",
      "alt_text": "Kitchen with dark countertops, stainless steel sink, and stove.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Stonebriar-034_Photo_Apartment-Interior_Staged-Kitchen_Angle-1_2026-06-15_Original-Size.jpg"
    },
    {
      "id": "ec_12508df3102f8f3a892b0aaf",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167613",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167613/01a0b666-8494-709d-a3b4-43feeeab477e.webp",
      "image_media": {
        "alt_text": "Kitchen with black appliances, double sink, and wood cabinets.",
        "public_id": "01a0b666-8494-709d-a3b4-43feeeab477e",
        "storage_key": "property/6767906449167613/01a0b666-8494-709d-a3b4-43feeeab477e.webp",
        "width": 3000,
        "height": 2001
      },
      "title": "Apartment",
      "description": "Fully equipped kitchen featuring black appliances, a double sink, ample cabinet space, and stylish countertops. A perfect space for cooking and entertaining.",
      "link": "false",
      "alt_text": "Kitchen with black appliances, double sink, and wood cabinets.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Stonebriar-034_Photo_Apartment-Interior_Staged-Kitchen_Angle-2_2026-06-15_Original-Size.jpg"
    },
    {
      "id": "ec_98a61f91a54a9b6a60f17cb9",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167613",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167613/01a0b666-9cc9-74fb-8579-43ff6d965a1b.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment balconies with brick and siding.",
        "public_id": "01a0b666-9cc9-74fb-8579-43ff6d965a1b",
        "storage_key": "property/6767906449167613/01a0b666-9cc9-74fb-8579-43ff6d965a1b.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "View of apartment balconies with brick and siding exteriors, offering a glimpse of outdoor living space.",
      "link": "false",
      "alt_text": "Exterior view of apartment balconies with brick and siding.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/12490 Quivira Rd-17.jpg"
    },
    {
      "id": "ec_3d18796c7db51ac654b0666a",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167613",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167613/01a0b666-b8fc-76fd-b8a2-ba29f60c7060.webp",
      "image_media": {
        "alt_text": "An aerial view of the property's swimming pool area with lounge chairs and umbrellas.",
        "public_id": "01a0b666-b8fc-76fd-b8a2-ba29f60c7060",
        "storage_key": "property/6767906449167613/01a0b666-b8fc-76fd-b8a2-ba29f60c7060.webp",
        "width": 3072,
        "height": 2047
      },
      "title": "Community",
      "description": "Relax and unwind by our sparkling outdoor swimming pool, surrounded by lush landscaping and comfortable seating.",
      "link": "false",
      "alt_text": "An aerial view of the property's swimming pool area with lounge chairs and umbrellas.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/12490 quivira rd-26(1).jpg"
    },
    {
      "id": "ec_7c08bb96d29669699e3d63b7",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167613",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167613/01a0b666-9304-70db-8c3f-af49810e3ff6.webp",
      "image_media": {
        "alt_text": "Aerial view of a resort-style swimming pool with a hot tub and lounge chairs.",
        "public_id": "01a0b666-9304-70db-8c3f-af49810e3ff6",
        "storage_key": "property/6767906449167613/01a0b666-9304-70db-8c3f-af49810e3ff6.webp",
        "width": 1200,
        "height": 799
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling swimming pool and relax in the adjacent hot tub, surrounded by comfortable lounge chairs and lush landscaping.",
      "link": "false",
      "alt_text": "Aerial view of a resort-style swimming pool with a hot tub and lounge chairs.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/12490 quivira rd-24 (2).jpg"
    },
    {
      "id": "ec_69cc53039cc49b0e1d7077fa",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167613",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167613/01a0b666-aab8-7718-8fe9-207011ea0c11.webp",
      "image_media": {
        "alt_text": "Entrance to the leasing center with colorful flower beds in the foreground.",
        "public_id": "01a0b666-aab8-7718-8fe9-207011ea0c11",
        "storage_key": "property/6767906449167613/01a0b666-aab8-7718-8fe9-207011ea0c11.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Welcome to our community! The leasing center entrance is beautifully adorned with vibrant flower beds, offering a warm and inviting first impression.",
      "link": "false",
      "alt_text": "Entrance to the leasing center with colorful flower beds in the foreground.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/34-12490 Quivira Rd-34(1).jpg"
    },
    {
      "id": "ec_3e8b817aec0d89758680f386",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167613",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167613/019fc989-ad63-76dd-9c7d-d9d65e180678.webp",
      "image_media": {
        "alt_text": "Fitness center with treadmills, ellipticals, and weight machines.",
        "public_id": "019fc989-ad63-76dd-9c7d-d9d65e180678",
        "storage_key": "property/6767906449167613/019fc989-ad63-76dd-9c7d-d9d65e180678.webp",
        "width": 1200,
        "height": 801
      },
      "title": "Community",
      "description": "Stay active in our fully-equipped fitness center, featuring a variety of cardio and strength training equipment for a great workout.",
      "link": "false",
      "alt_text": "Fitness center with treadmills, ellipticals, and weight machines.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/932facaa-703e-4103-b007-a5cfbb3caf5a(1).jpg"
    },
    {
      "id": "ec_7b3a7969dbb94e509c237f23",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167613",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167613/01a0b666-b841-714e-b88c-72082f18c3aa.webp",
      "image_media": {
        "alt_text": "Community business center with computers and seating area.",
        "public_id": "01a0b666-b841-714e-b88c-72082f18c3aa",
        "storage_key": "property/6767906449167613/01a0b666-b841-714e-b88c-72082f18c3aa.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Utilize our convenient business center, equipped with computers and a comfortable seating area, for all your professional needs.",
      "link": "false",
      "alt_text": "Community business center with computers and seating area.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/12490 Quivira Rd-31.jpg"
    },
    {
      "id": "ec_e7c8e592d19e17a63b9543f2",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167613",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167613/01a0b666-d539-76aa-9f9e-47616120ef71.webp",
      "image_media": {
        "alt_text": "Aerial view of apartment buildings, a pool, and a golf course.",
        "public_id": "01a0b666-d539-76aa-9f9e-47616120ef71",
        "storage_key": "property/6767906449167613/01a0b666-d539-76aa-9f9e-47616120ef71.webp",
        "width": 3072,
        "height": 2047
      },
      "title": "Community",
      "description": "Aerial view showcasing the apartment community, complete with a sparkling pool, surrounding lush greenery, and proximity to a golf course.",
      "link": "false",
      "alt_text": "Aerial view of apartment buildings, a pool, and a golf course.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/12490 quivira rd-21.jpg"
    },
    {
      "id": "ec_deec99476f3b41ede885cea4",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167613",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167613/01a0b666-ebea-7592-b58f-4c5a55de022e.webp",
      "image_media": {
        "alt_text": "Aerial view of apartment buildings with manicured lawns and mature trees.",
        "public_id": "01a0b666-ebea-7592-b58f-4c5a55de022e",
        "storage_key": "property/6767906449167613/01a0b666-ebea-7592-b58f-4c5a55de022e.webp",
        "width": 3072,
        "height": 2047
      },
      "title": "Community",
      "description": "Discover comfortable living in this charming apartment community, featuring well-maintained buildings surrounded by lush greenery and ample parking.",
      "link": "false",
      "alt_text": "Aerial view of apartment buildings with manicured lawns and mature trees.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/12490 quivira rd-20.jpg"
    },
    {
      "id": "ec_6078fd818fa09a01b0cc3195",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167613",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167613/01a0b666-f44e-7329-9a51-8e7a7d548f98.webp",
      "image_media": {
        "alt_text": "Exterior of apartment building with brick and grey siding, balconies, and manicured lawns.",
        "public_id": "01a0b666-f44e-7329-9a51-8e7a7d548f98",
        "storage_key": "property/6767906449167613/01a0b666-f44e-7329-9a51-8e7a7d548f98.webp",
        "width": 3072,
        "height": 2047
      },
      "title": "Community",
      "description": "Beautifully maintained apartment building exterior featuring multiple levels, balconies, and lush green landscaping.",
      "link": "false",
      "alt_text": "Exterior of apartment building with brick and grey siding, balconies, and manicured lawns.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/12490 Quivira Rd-28.jpg"
    },
    {
      "id": "ec_b44df1a8ec5b23806ba41d96",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167613",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167613/01a0b666-e813-751f-b02d-3d4cdd1b6a8d.webp",
      "image_media": {
        "alt_text": "Apartment buildings surrounded by manicured lawns and trees.",
        "public_id": "01a0b666-e813-751f-b02d-3d4cdd1b6a8d",
        "storage_key": "property/6767906449167613/01a0b666-e813-751f-b02d-3d4cdd1b6a8d.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Beautifully maintained lawns and mature trees provide a serene setting for these apartment buildings.",
      "link": "false",
      "alt_text": "Apartment buildings surrounded by manicured lawns and trees.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Stonebriar-034_Photo_Exterior_Green-Space-2_2026-06-15_Original-Size.jpg"
    },
    {
      "id": "ec_038954b86d05b3e920edc326",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167613",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167613/01a0b666-fef6-72c6-b9b5-5ccdbb95d765.webp",
      "image_media": {
        "alt_text": "Winding paved walkway through a lush green park with mature trees and apartment buildings in the background.",
        "public_id": "01a0b666-fef6-72c6-b9b5-5ccdbb95d765",
        "storage_key": "property/6767906449167613/01a0b666-fef6-72c6-b9b5-5ccdbb95d765.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Enjoy the serene atmosphere of our community with beautifully manicured grounds and scenic walking paths, perfect for a relaxing stroll.",
      "link": "false",
      "alt_text": "Winding paved walkway through a lush green park with mature trees and apartment buildings in the background.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Stonebriar-034_Photo_Exterior_Green-Space-1_2026-06-15_Original-Size.jpg"
    },
    {
      "id": "ec_9ba5a88254a768fef644068f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167613",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167613/01a0b666-fa43-750a-9474-712df9f12ef3.webp",
      "image_media": {
        "alt_text": "A paved walking path curves through a lush green lawn surrounded by mature trees.",
        "public_id": "01a0b666-fa43-750a-9474-712df9f12ef3",
        "storage_key": "property/6767906449167613/01a0b666-fa43-750a-9474-712df9f12ef3.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Enjoy the beautiful green spaces and walking paths at our community.",
      "link": "false",
      "alt_text": "A paved walking path curves through a lush green lawn surrounded by mature trees.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Stonebriar-034_Photo_Exterior_Green-Space-3_2026-06-15_Original-Size.jpg"
    },
    {
      "id": "ec_042ae188cb3502a3a286122f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167613",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167613/01a0b667-2ee7-7263-8a28-840dcae4a267.webp",
      "image_media": {
        "alt_text": "Garage with multiple bays, including covered parking and a red car.",
        "public_id": "01a0b667-2ee7-7263-8a28-840dcae4a267",
        "storage_key": "property/6767906449167613/01a0b667-2ee7-7263-8a28-840dcae4a267.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Convenient garage and covered parking options available at the community.",
      "link": "false",
      "alt_text": "Garage with multiple bays, including covered parking and a red car.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Stonebriar-034_Photo_Amenities_Garages_2026-06-15_Original-Size.jpg"
    },
    {
      "id": "ec_873ca09cdb5952768a0f01fe",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167613",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167613/01a0b667-1785-716a-9619-4ea39a9517a1.webp",
      "image_media": {
        "alt_text": "Covered parking spaces with apartment buildings in the background.",
        "public_id": "01a0b667-1785-716a-9619-4ea39a9517a1",
        "storage_key": "property/6767906449167613/01a0b667-1785-716a-9619-4ea39a9517a1.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Covered parking spaces offer protection from the elements for your vehicle, with apartment buildings visible in the background.",
      "link": "false",
      "alt_text": "Covered parking spaces with apartment buildings in the background.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Stonebriar-034_Photo_Amenities_Carports_2026-06-15_Original-Size.jpg"
    },
    {
      "id": "ec_deeaba9397d5fc997a0ceb76",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167613",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167613/01a0b667-2bc7-733e-a29a-80f55fdd6fa5.webp",
      "image_media": {
        "alt_text": "Exterior of leasing office and covered parking at apartment complex.",
        "public_id": "01a0b667-2bc7-733e-a29a-80f55fdd6fa5",
        "storage_key": "property/6767906449167613/01a0b667-2bc7-733e-a29a-80f55fdd6fa5.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Discover your new home at our apartment community. This image shows the leasing office and covered parking, providing a glimpse of the convenient amenities available.",
      "link": "false",
      "alt_text": "Exterior of leasing office and covered parking at apartment complex.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Stonebriar-034_Photo_Amenities_Car-Wash-Station_Angle-1_2026-06-15_Original-Size.jpg"
    },
    {
      "id": "ec_b31ff5dc179f936315c6d113",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167613",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167613/01a0b667-2ede-75fb-9281-906d14d0000c.webp",
      "image_media": {
        "alt_text": "Exterior of apartment buildings with a covered walkway and green lawn.",
        "public_id": "01a0b667-2ede-75fb-9281-906d14d0000c",
        "storage_key": "property/6767906449167613/01a0b667-2ede-75fb-9281-906d14d0000c.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Exterior view of apartment buildings featuring a covered walkway, neat lawn, and mature trees under a clear blue sky.",
      "link": "false",
      "alt_text": "Exterior of apartment buildings with a covered walkway and green lawn.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Stonebriar-034_Photo_Amenities_Car-Wash-Station_Angle-2_2026-06-15_Original-Size.jpg"
    },
    {
      "id": "ec_f455d9db3980e3517af81905",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167613",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167613/01a0b667-3509-756c-a3a0-4b9a8ecdc50f.webp",
      "image_media": {
        "alt_text": "Covered outdoor parking area with brick walls and a hose on the wall.",
        "public_id": "01a0b667-3509-756c-a3a0-4b9a8ecdc50f",
        "storage_key": "property/6767906449167613/01a0b667-3509-756c-a3a0-4b9a8ecdc50f.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Convenient covered parking available for residents, complete with a hose for easy vehicle cleaning.",
      "link": "false",
      "alt_text": "Covered outdoor parking area with brick walls and a hose on the wall.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Stonebriar-034_Photo_Amenities_Car-Wash-Station_Angle-3_2026-06-15_Original-Size.jpg"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_233fbb6b-b6d5-41c1-a589-2610ade55e12",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167613",
      "source": "custom",
      "poi_name": "Sawasdee Thai Cuisine",
      "poi_type": "Restaurants",
      "poi_address": "11838 Quivira Rd, Overland Park, KS 66210, USA",
      "poi_short_description": "Curries, spring rolls & other Thai staples served in a low-key dining room with traditional decor.",
      "poi_long_description": "Curries, spring rolls & other Thai staples served in a low-key dining room with traditional decor.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167613/019fc98e-7ca7-7433-9eb1-df43320e48fb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc98e-7ca7-7433-9eb1-df43320e48fb",
        "storage_key": "property/6767906449167613/019fc98e-7ca7-7433-9eb1-df43320e48fb.webp",
        "width": 1280,
        "height": 708
      },
      "poi_business_url": "http://sawasdeethaiop.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5700896036165937418&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sawasdee-thai-cuisine",
      "poi_latitude": "38.9137169",
      "poi_longitude": "-94.7242789",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 913-338-1673",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167613/019fc989-bf42-746e-89e1-2d1abd0e4dad.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc989-bf42-746e-89e1-2d1abd0e4dad",
        "storage_key": "property/6767906449167613/019fc989-bf42-746e-89e1-2d1abd0e4dad.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2aXaDMrqwIcRCmkagb2mHU8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "thai_restaurant"
    },
    {
      "id": "custom_6a40f1ad-f39a-40d4-8c70-44cfd5f7b213",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167613",
      "source": "custom",
      "poi_name": "Talk of the Town Grill & Bar",
      "poi_type": "Restaurants",
      "poi_address": "11922 W 119th St, Overland Park, KS 66213, USA",
      "poi_short_description": "Wide-ranging American menu & sizable microbrew selection offered in a casual sports-bar setting.",
      "poi_long_description": "Wide-ranging American menu & sizable microbrew selection offered in a casual sports-bar setting.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167613/019ff6a9-6080-732f-8120-a5f96ce90bf2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6a9-6080-732f-8120-a5f96ce90bf2",
        "storage_key": "property/6767906449167613/019ff6a9-6080-732f-8120-a5f96ce90bf2.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.talkofthetowngrill.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11519808852011712913&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "talk-of-the-town-grill--bar",
      "poi_latitude": "38.9134106",
      "poi_longitude": "-94.7252605",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 913-661-9922",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167613/019fc989-bf42-746e-89e1-2d1abd0e4dad.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc989-bf42-746e-89e1-2d1abd0e4dad",
        "storage_key": "property/6767906449167613/019fc989-bf42-746e-89e1-2d1abd0e4dad.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJX1JPRbTqwIcRkQGPyB2V3p8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_91ecfb12-2af2-4b5b-8a17-4bfc660222ce",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167613",
      "source": "custom",
      "poi_name": "Barley's Kitchen + Tap",
      "poi_type": "Restaurants",
      "poi_address": "11924 W 119th St, Overland Park, KS 66213, USA",
      "poi_short_description": "Brewpub offering a full-length upscale American comfort-food menu, global beer list & TV-watching.",
      "poi_long_description": "Brewpub offering a full-length upscale American comfort-food menu, global beer list & TV-watching.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167613/019ff6a9-5b78-732d-ad8d-add0a33a0df2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6a9-5b78-732d-ad8d-add0a33a0df2",
        "storage_key": "property/6767906449167613/019ff6a9-5b78-732d-ad8d-add0a33a0df2.webp",
        "width": 999,
        "height": 888
      },
      "poi_business_url": "http://barleyskitchenandtap.com/op/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7369584364347950482&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "barleys-kitchen--tap",
      "poi_latitude": "38.9133583",
      "poi_longitude": "-94.7257415",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 913-663-4099",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167613/019fc989-bf42-746e-89e1-2d1abd0e4dad.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc989-bf42-746e-89e1-2d1abd0e4dad",
        "storage_key": "property/6767906449167613/019fc989-bf42-746e-89e1-2d1abd0e4dad.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJr63MWrTqwIcRkoU7A-8FRmY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_b6e30809-df4b-45cc-9de3-fa9fb3d1a482",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167613",
      "source": "custom",
      "poi_name": "Louie's Wine Dive and Kitchen 119",
      "poi_type": "Restaurants",
      "poi_address": "6701 W 119th St, Overland Park, KS 66209, USA",
      "poi_short_description": "Comfortable destination known for locally sourced comfort food & an extensive wine list.",
      "poi_long_description": "Comfortable destination known for locally sourced comfort food & an extensive wine list.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167613/019ff6a9-5ac4-7283-b184-fe4833670999.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6a9-5ac4-7283-b184-fe4833670999",
        "storage_key": "property/6767906449167613/019ff6a9-5ac4-7283-b184-fe4833670999.webp",
        "width": 1024,
        "height": 682
      },
      "poi_business_url": "https://www.louieswinedive.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17363784540288348534&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "louies-wine-dive-and-kitchen-119",
      "poi_latitude": "38.9123445",
      "poi_longitude": "-94.6636772",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 30 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 913-469-4177",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167613/019ff6a9-9541-7394-8a00-134950c9971c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a9-9541-7394-8a00-134950c9971c",
        "storage_key": "property/6767906449167613/019ff6a9-9541-7394-8a00-134950c9971c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJGUqh8BTqwIcRdnFOyAqO-PA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "wine_bar"
    },
    {
      "id": "custom_14753606-4bd2-4083-8228-695ee7803004",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167613",
      "source": "custom",
      "poi_name": "Red Door Woodfired Grill",
      "poi_type": "Restaurants",
      "poi_address": "11851 Roe Ave, Leawood, KS 66211, USA",
      "poi_short_description": "This casual American eatery with a brick patio offers foods cooked on a wood-fired grill.",
      "poi_long_description": "This casual American eatery with a brick patio offers foods cooked on a wood-fired grill.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167613/019ff6a9-647d-7079-bffe-fa3a1bd71e0d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6a9-647d-7079-bffe-fa3a1bd71e0d",
        "storage_key": "property/6767906449167613/019ff6a9-647d-7079-bffe-fa3a1bd71e0d.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://reddoorgrill.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18358751246709491710&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "red-door-woodfired-grill",
      "poi_latitude": "38.9139376",
      "poi_longitude": "-94.6376498",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "2 hours 2 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 913-227-4959",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167613/019fc989-bf42-746e-89e1-2d1abd0e4dad.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc989-bf42-746e-89e1-2d1abd0e4dad",
        "storage_key": "property/6767906449167613/019fc989-bf42-746e-89e1-2d1abd0e4dad.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJV6WDqfPpwIcR_gfhc_1ix_4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_8158630b-36ab-4378-9aec-e1938d9857e5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167613",
      "source": "custom",
      "poi_name": "Joe's KC BBQ",
      "poi_type": "Restaurants",
      "poi_address": "11723 Roe Ave, Leawood, KS 66211, USA",
      "poi_short_description": "Relaxed BBQ pit stop for slabs of ribs, pulled pork sandwiches, meat by the pound & sides.",
      "poi_long_description": "Relaxed BBQ pit stop for slabs of ribs, pulled pork sandwiches, meat by the pound & sides.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167613/019fc988-5dde-705b-a6c8-a98e7178d9f6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc988-5dde-705b-a6c8-a98e7178d9f6",
        "storage_key": "property/6767906449167613/019fc988-5dde-705b-a6c8-a98e7178d9f6.webp",
        "width": 480,
        "height": 269
      },
      "poi_business_url": "https://www.joeskc.com/?olonwp=JjBtp_vMLk25gkYh_bnoiQ",
      "poi_directions_map_url": "https://maps.google.com/?cid=9892923460626970307&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "joes-kc-bbq",
      "poi_latitude": "38.9153235",
      "poi_longitude": "-94.6393056",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "2 hours 3 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 913-338-5151",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167613/019fc989-bf42-746e-89e1-2d1abd0e4dad.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc989-bf42-746e-89e1-2d1abd0e4dad",
        "storage_key": "property/6767906449167613/019fc989-bf42-746e-89e1-2d1abd0e4dad.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJPWiXZ_PpwIcRw3bM9Hi5Sok",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barbecue_restaurant"
    },
    {
      "id": "custom_5b07b41f-00fe-4a74-b016-789e65b286ba",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167613",
      "source": "custom",
      "poi_name": "Maggiano's Little Italy",
      "poi_type": "Restaurants",
      "poi_address": "7025 W 135th St, Overland Park, KS 66223, USA",
      "poi_short_description": "Semi-upscale chain for classic Italian fare served family-style in a relaxed, polished space.",
      "poi_long_description": "Semi-upscale chain for classic Italian fare served family-style in a relaxed, polished space.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167613/01a0b665-ab8d-74f9-a6e2-7a92e6d6e138.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b665-ab8d-74f9-a6e2-7a92e6d6e138",
        "storage_key": "property/6767906449167613/01a0b665-ab8d-74f9-a6e2-7a92e6d6e138.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.maggianos.com/locations/Kansas/Overland+Park/7025-w.-135th-street?utm_source=google&utm_medium=organic&utm_campaign=Maggianos",
      "poi_directions_map_url": "https://maps.google.com/?cid=8213715666550259878&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "maggianos-little-italy",
      "poi_latitude": "38.883238",
      "poi_longitude": "-94.666864",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 38 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 913-897-8020",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167613/019fc989-bf42-746e-89e1-2d1abd0e4dad.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc989-bf42-746e-89e1-2d1abd0e4dad",
        "storage_key": "property/6767906449167613/019fc989-bf42-746e-89e1-2d1abd0e4dad.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJS3qOvMLBwIcRpgDKbuH6_HE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "custom_6afff771-6c4e-4221-9ab7-4af81ca7afb8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167613",
      "source": "custom",
      "poi_name": "Corner Bakery Cafe",
      "poi_type": "Restaurants",
      "poi_address": "6721 W 135th St, Overland Park, KS 66223, USA",
      "poi_short_description": "Casual, counter-serve cafe chain offering a standard menu of sandwiches, pasta & pastries.",
      "poi_long_description": "Casual, counter-serve cafe chain offering a standard menu of sandwiches, pasta & pastries.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167613/01a0b665-af08-708c-b6de-02c96ca78912.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b665-af08-708c-b6de-02c96ca78912",
        "storage_key": "property/6767906449167613/01a0b665-af08-708c-b6de-02c96ca78912.webp",
        "width": 1280,
        "height": 606
      },
      "poi_business_url": "https://www.cornerbakerycafe.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10304885892902949755&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "corner-bakery-cafe",
      "poi_latitude": "38.8833555",
      "poi_longitude": "-94.6635419",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 43 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 913-955-2370",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167613/019fc994-089d-763b-826c-d32cc96d9204.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc994-089d-763b-826c-d32cc96d9204",
        "storage_key": "property/6767906449167613/019fc994-089d-763b-826c-d32cc96d9204.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJ--j1b-jBwIcRexNqOR9PAo8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "cafe"
    },
    {
      "id": "custom_1272f034-4297-4ada-9d7b-fdcdfd4950bd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167613",
      "source": "custom",
      "poi_name": "Q39 - South",
      "poi_type": "Restaurants",
      "poi_address": "11051 Antioch Rd, Overland Park, KS 66210, USA",
      "poi_short_description": "Casual joint for Kansas City BBQ, burgers, wings and sandwiches made in-house, plus a fireplace.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167613/019fc988-5e2c-702d-9827-36e9357b441d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc988-5e2c-702d-9827-36e9357b441d",
        "storage_key": "property/6767906449167613/019fc988-5e2c-702d-9827-36e9357b441d.webp",
        "width": 960,
        "height": 543
      },
      "poi_business_url": "https://q39kc.com/locations/overland-park-bbq/?utm_source=Google&utm_medium=Maps&utm_campaign=GBP_south",
      "poi_directions_map_url": "https://maps.google.com/?cid=10944240241970651302&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "q39---south",
      "poi_latitude": "38.9287968",
      "poi_longitude": "-94.6857828",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 27 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 913-951-4500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167613/019fc989-bf42-746e-89e1-2d1abd0e4dad.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc989-bf42-746e-89e1-2d1abd0e4dad",
        "storage_key": "property/6767906449167613/019fc989-bf42-746e-89e1-2d1abd0e4dad.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0fk1I1bqwIcRpiAy14PA4Zc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barbecue_restaurant"
    },
    {
      "id": "custom_7331230b-d889-433d-b684-52d5c84b9d72",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167613",
      "source": "custom",
      "poi_name": "Rye Leawood",
      "poi_type": "Restaurants",
      "poi_address": "10551 Mission Rd, Leawood, KS 66206, USA",
      "poi_short_description": "Farm-to-table American fare & rye cocktails served in a stylish, urban-farmhouse setting.",
      "poi_long_description": "Farm-to-table American fare & rye cocktails served in a stylish, urban-farmhouse setting.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167613/01a0b665-ab94-76ca-b13c-076347a4c65b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b665-ab94-76ca-b13c-076347a4c65b",
        "storage_key": "property/6767906449167613/01a0b665-ab94-76ca-b13c-076347a4c65b.webp",
        "width": 600,
        "height": 312
      },
      "poi_business_url": "https://www.ryekc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14342125015295398366&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rye-leawood",
      "poi_latitude": "38.9345806",
      "poi_longitude": "-94.6282056",
      "poi_miles_from_property": "7.1",
      "poi_walking_minutes": "2 hours 36 mins",
      "poi_biking_minutes": "53 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 913-642-5800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167613/019fc989-bf42-746e-89e1-2d1abd0e4dad.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc989-bf42-746e-89e1-2d1abd0e4dad",
        "storage_key": "property/6767906449167613/019fc989-bf42-746e-89e1-2d1abd0e4dad.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJWYlIkJ7pwIcR3hHtrLZ2Ccc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_ded7e8a2-48b5-489e-a828-ef0157b6180e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167613",
      "source": "custom",
      "poi_name": "The Brew Top Pub and Patio",
      "poi_type": "Restaurants",
      "poi_address": "6601 W 135th St, Overland Park, KS 66223, USA",
      "poi_short_description": "Sizable, easygoing hangout with a patio offering pub grub, a large beer selection & live music.",
      "poi_long_description": "Sizable, easygoing hangout with a patio offering pub grub, a large beer selection & live music.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167613/01a0b665-ad85-777f-a5d8-d3335e36fedc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b665-ad85-777f-a5d8-d3335e36fedc",
        "storage_key": "property/6767906449167613/01a0b665-ad85-777f-a5d8-d3335e36fedc.webp",
        "width": 1280,
        "height": 950
      },
      "poi_business_url": "https://www.thebrewtop.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=683704552941770679&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-brew-top-pub-and-patio",
      "poi_latitude": "38.8810941",
      "poi_longitude": "-94.6620258",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 48 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 913-897-5500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167613/019fc989-bf42-746e-89e1-2d1abd0e4dad.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc989-bf42-746e-89e1-2d1abd0e4dad",
        "storage_key": "property/6767906449167613/019fc989-bf42-746e-89e1-2d1abd0e4dad.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJWcCvoOnBwIcRt1dpIasBfQk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar_and_grill"
    },
    {
      "id": "custom_1790b4e9-4b9a-4586-919c-c1628381cd33",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167613",
      "source": "custom",
      "poi_name": "Redrock Canyon Grill",
      "poi_type": "Restaurants",
      "poi_address": "13505 Metcalf Ave, Overland Park, KS 66223, USA",
      "poi_short_description": "Easygoing bistro & bar turning out wood-fired rotisserie chicken & Southwest-inspired dishes.",
      "poi_long_description": "Easygoing bistro & bar turning out wood-fired rotisserie chicken & Southwest-inspired dishes.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167613/01a0b665-b30a-77fc-a0c4-d453a9c998ab.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b665-b30a-77fc-a0c4-d453a9c998ab",
        "storage_key": "property/6767906449167613/01a0b665-b30a-77fc-a0c4-d453a9c998ab.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.redrockcanyongrill.com/locations/overland-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=938507233962655685&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "redrock-canyon-grill",
      "poi_latitude": "38.8829467",
      "poi_longitude": "-94.6672726",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 38 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 913-239-0202",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167613/019fc989-bf42-746e-89e1-2d1abd0e4dad.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc989-bf42-746e-89e1-2d1abd0e4dad",
        "storage_key": "property/6767906449167613/019fc989-bf42-746e-89e1-2d1abd0e4dad.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJtZlOwMLBwIcRxX96W1s_Bg0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_919c3199-827b-4f74-8fd0-2ac4322b1672",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167613",
      "source": "custom",
      "poi_name": "Revocup Coffee Leawood",
      "poi_type": "Restaurants",
      "poi_address": "5037 West 117th street Town Center Plaza & Crossing, Leawood, KS 66211, USA",
      "poi_short_description": "Relaxed coffeehouse with locally roasted single-origin beans and espresso, plus light bites.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167613/01a0b665-ae49-76d8-b53b-6f70554cf24f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b665-ae49-76d8-b53b-6f70554cf24f",
        "storage_key": "property/6767906449167613/01a0b665-ae49-76d8-b53b-6f70554cf24f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://revocupleawood.square.site/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10553656821875865900&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "revocup-coffee-leawood",
      "poi_latitude": "38.9152007",
      "poi_longitude": "-94.6435208",
      "poi_miles_from_property": "5.3",
      "poi_walking_minutes": "1 hour 57 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 913-387-4938",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167613/019fc994-089d-763b-826c-d32cc96d9204.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc994-089d-763b-826c-d32cc96d9204",
        "storage_key": "property/6767906449167613/019fc994-089d-763b-826c-d32cc96d9204.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJn2nIEunpwIcRLPlJvfYedpI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "custom_53fbf0cd-00f0-4036-84bb-4503ab48c61c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167613",
      "source": "custom",
      "poi_name": "Johnny Cascone's Italian Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "6863 W 91st St, Overland Park, KS 66212, USA",
      "poi_short_description": "Established, old-school eatery making classic Italian fare such as ravioli & chicken parmigiana.",
      "poi_long_description": "Established, old-school eatery making classic Italian fare such as ravioli & chicken parmigiana.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167613/01a0b665-acda-742d-aecc-07c6914ad59c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b665-acda-742d-aecc-07c6914ad59c",
        "storage_key": "property/6767906449167613/01a0b665-acda-742d-aecc-07c6914ad59c.webp",
        "width": 1200,
        "height": 673
      },
      "poi_business_url": "http://www.johnnycascones.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16309541528158629823&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "johnny-cascones-italian-restaurant",
      "poi_latitude": "38.9636217",
      "poi_longitude": "-94.6653404",
      "poi_miles_from_property": "7.2",
      "poi_walking_minutes": "2 hours 40 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 913-381-6837",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167613/019fc989-bf42-746e-89e1-2d1abd0e4dad.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc989-bf42-746e-89e1-2d1abd0e4dad",
        "storage_key": "property/6767906449167613/019fc989-bf42-746e-89e1-2d1abd0e4dad.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJj7qEtOzrwIcRv29gs5shV-I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "custom_3e995de2-d1fd-4ff3-9475-6c09440b1186",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167613",
      "source": "custom",
      "poi_name": "Taqueria La Nueva - Overland Park",
      "poi_type": "Restaurants",
      "poi_address": "12561 Antioch Rd, Overland Park, KS 66213, USA",
      "poi_short_description": "Casual spot specializing in authentic Mexican fare, including tacos and burritos.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167613/01a0b665-b2f0-76be-adbd-7bfd250798b3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b665-b2f0-76be-adbd-7bfd250798b3",
        "storage_key": "property/6767906449167613/01a0b665-b2f0-76be-adbd-7bfd250798b3.webp",
        "width": 828,
        "height": 596
      },
      "poi_business_url": "http://tacoslanueva.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9992242950197903082&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "taqueria-la-nueva---overland-park",
      "poi_latitude": "38.9000573",
      "poi_longitude": "-94.6845757",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 913-766-5001",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167613/019fc989-bf42-746e-89e1-2d1abd0e4dad.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc989-bf42-746e-89e1-2d1abd0e4dad",
        "storage_key": "property/6767906449167613/019fc989-bf42-746e-89e1-2d1abd0e4dad.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8RqKoPLrwIcR6n7yowWUq4o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_ad6fa4d6-fdcd-4f02-9b78-8a7895af393d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167613",
      "source": "custom",
      "poi_name": "Pleasant Ridge Elementary School",
      "poi_type": "Education",
      "poi_address": "12235 Rosehill St, Overland Park, KS 66213, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167613/019ff6a9-6fe6-77c6-8c84-a856c6abbfff.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6a9-6fe6-77c6-8c84-a856c6abbfff",
        "storage_key": "property/6767906449167613/019ff6a9-6fe6-77c6-8c84-a856c6abbfff.webp",
        "width": 1280,
        "height": 730
      },
      "poi_business_url": "http://www.olatheschools.org/pleasantridge",
      "poi_directions_map_url": "https://maps.google.com/?cid=11267647678519589529&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pleasant-ridge-elementary-school",
      "poi_latitude": "38.9072187",
      "poi_longitude": "-94.7345938",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 913-780-7590",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167613/019fc989-c2e9-754f-ba38-e04c0a3f68ed.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc989-c2e9-754f-ba38-e04c0a3f68ed",
        "storage_key": "property/6767906449167613/019fc989-c2e9-754f-ba38-e04c0a3f68ed.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJKcvLyU6VwIcRmTpqdN25Xpw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_23944fc5-fff5-42d2-9ada-6979f1a8c321",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167613",
      "source": "custom",
      "poi_name": "California Trail Middle School",
      "poi_type": "Education",
      "poi_address": "13775 W 133rd St, Olathe, KS 66062, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.olatheschools.org/californiatrail/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4023738896053685227&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "california-trail-middle-school",
      "poi_latitude": "38.8860707",
      "poi_longitude": "-94.7466726",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "47 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 913-780-7220",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167613/019fc989-c2e9-754f-ba38-e04c0a3f68ed.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc989-c2e9-754f-ba38-e04c0a3f68ed",
        "storage_key": "property/6767906449167613/019fc989-c2e9-754f-ba38-e04c0a3f68ed.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJBZgmSP6_wIcR68szEDUx1zc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_162c578b-18de-43fa-9157-c9306c4ce1de",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167613",
      "source": "custom",
      "poi_name": "Olathe East High School",
      "poi_type": "Education",
      "poi_address": "14545 W 127th St, Olathe, KS 66062, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167613/019ff6d3-08d0-72dd-ba03-b664a95c0b32.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6d3-08d0-72dd-ba03-b664a95c0b32",
        "storage_key": "property/6767906449167613/019ff6d3-08d0-72dd-ba03-b664a95c0b32.webp",
        "width": 1280,
        "height": 590
      },
      "poi_business_url": "http://www.olatheschools.org/east/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4226639083448974343&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "olathe-east-high-school",
      "poi_latitude": "38.8956297",
      "poi_longitude": "-94.7538396",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "44 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 913-780-7120",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167613/019fc989-c2e9-754f-ba38-e04c0a3f68ed.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc989-c2e9-754f-ba38-e04c0a3f68ed",
        "storage_key": "property/6767906449167613/019fc989-c2e9-754f-ba38-e04c0a3f68ed.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJg4KXUWGVwIcRBzzCStoJqDo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_022d80bd-e2e9-4bba-b424-5b43ff4cd479",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167613",
      "source": "custom",
      "poi_name": "New Horizon Academy",
      "poi_type": "Education",
      "poi_address": "11920 Quivira Rd, Overland Park, KS 66213, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167613/01a01010-8141-730c-be84-18e1ccdfce6d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a01010-8141-730c-be84-18e1ccdfce6d",
        "storage_key": "property/6767906449167613/01a01010-8141-730c-be84-18e1ccdfce6d.webp",
        "width": 1024,
        "height": 1280
      },
      "poi_business_url": "https://www.newhorizonacademy.net/location/overland-park-ks/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17338355438709389589&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "new-horizon-academy",
      "poi_latitude": "38.91157",
      "poi_longitude": "-94.7244149",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 913-400-2670",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167613/019fc989-c2e9-754f-ba38-e04c0a3f68ed.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc989-c2e9-754f-ba38-e04c0a3f68ed",
        "storage_key": "property/6767906449167613/019fc989-c2e9-754f-ba38-e04c0a3f68ed.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ11iLHg3rwIcRFTm8sWg2nvA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "custom_474ffb1a-8719-44d5-add4-45d47f4ee4d7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167613",
      "source": "custom",
      "poi_name": "Hillcrest Christian Early Learning Center",
      "poi_type": "Education",
      "poi_address": "11411 S Quivira Rd, Overland Park, KS 66210, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167613/019fc990-efa0-73be-8535-ce5c66f1689c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc990-efa0-73be-8535-ce5c66f1689c",
        "storage_key": "property/6767906449167613/019fc990-efa0-73be-8535-ce5c66f1689c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.hillcrestchristianelc.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2076367160619077010&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hillcrest-christian-early-learning-center",
      "poi_latitude": "38.921786",
      "poi_longitude": "-94.7226869",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 913-663-1997",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167613/019fc989-c2e9-754f-ba38-e04c0a3f68ed.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc989-c2e9-754f-ba38-e04c0a3f68ed",
        "storage_key": "property/6767906449167613/019fc989-c2e9-754f-ba38-e04c0a3f68ed.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJwcY72M3qwIcRko38d-680Bw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "custom_3eec293b-243e-48a1-b77a-e0a97c116b2b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167613",
      "source": "custom",
      "poi_name": "University of Kansas Edwards Campus",
      "poi_type": "Education",
      "poi_address": "12600 S Quivira Rd, Overland Park, KS 66213, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167613/019ff6d3-09dd-7029-a9f8-45a90ee88d78.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6d3-09dd-7029-a9f8-45a90ee88d78",
        "storage_key": "property/6767906449167613/019ff6d3-09dd-7029-a9f8-45a90ee88d78.webp",
        "width": 1280,
        "height": 795
      },
      "poi_business_url": "http://edwardscampus.ku.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15421529977661014929&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "university-of-kansas-edwards-campus",
      "poi_latitude": "38.900081",
      "poi_longitude": "-94.7254776",
      "poi_miles_from_property": "0.2",
      "poi_walking_minutes": "6 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 913-897-8400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167613/019fc989-c2e9-754f-ba38-e04c0a3f68ed.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc989-c2e9-754f-ba38-e04c0a3f68ed",
        "storage_key": "property/6767906449167613/019fc989-c2e9-754f-ba38-e04c0a3f68ed.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJcfRKua3qwIcRkcOF085HBNY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_93a15224-590c-4caf-a2c6-dac7a333e555",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167613",
      "source": "custom",
      "poi_name": "Johnson County Community College",
      "poi_type": "Education",
      "poi_address": "12345 College Blvd, Overland Park, KS 66210, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167613/019fc988-7021-7629-9351-7e39c3443888.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc988-7021-7629-9351-7e39c3443888",
        "storage_key": "property/6767906449167613/019fc988-7021-7629-9351-7e39c3443888.webp",
        "width": 960,
        "height": 540
      },
      "poi_business_url": "https://www.jccc.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4939079639992649295&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "johnson-county-community-college",
      "poi_latitude": "38.9237619",
      "poi_longitude": "-94.7303185",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 913-469-8500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167613/019fc989-c2e9-754f-ba38-e04c0a3f68ed.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc989-c2e9-754f-ba38-e04c0a3f68ed",
        "storage_key": "property/6767906449167613/019fc989-c2e9-754f-ba38-e04c0a3f68ed.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJEejhg2TrwIcRT0Ygo8Mii0Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_94b86232-cbc1-423e-b898-c41e7580dc84",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167613",
      "source": "custom",
      "poi_name": "Hiersteiner Child Development Center",
      "poi_type": "Education",
      "poi_address": "66210 S Campus Dr, Overland Park, KS 66210, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.jccc.edu/campus-life/childcare/",
      "poi_directions_map_url": "https://maps.google.com/?cid=234373460621827390&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hiersteiner-child-development-center",
      "poi_latitude": "38.9232807",
      "poi_longitude": "-94.7351434",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 913-469-4438",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167613/019fc989-c2e9-754f-ba38-e04c0a3f68ed.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc989-c2e9-754f-ba38-e04c0a3f68ed",
        "storage_key": "property/6767906449167613/019fc989-c2e9-754f-ba38-e04c0a3f68ed.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJZSeSKS6VwIcRPp0ksWupQAM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "educational_institution"
    },
    {
      "id": "custom_8c75852a-e78f-411b-b7ec-34a56e6074ad",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167613",
      "source": "custom",
      "poi_name": "Overland Trail Middle School",
      "poi_type": "Education",
      "poi_address": "6201 W 133rd St, Overland Park, KS 66209, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167613/019fc990-ff44-7690-8495-63eebb881f8f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc990-ff44-7690-8495-63eebb881f8f",
        "storage_key": "property/6767906449167613/019fc990-ff44-7690-8495-63eebb881f8f.webp",
        "width": 1280,
        "height": 543
      },
      "poi_business_url": "https://www.bluevalleyk12.org/OTM",
      "poi_directions_map_url": "https://maps.google.com/?cid=15599445353126869038&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "overland-trail-middle-school",
      "poi_latitude": "38.8855363",
      "poi_longitude": "-94.6545605",
      "poi_miles_from_property": "4.9",
      "poi_walking_minutes": "1 hour 49 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 913-239-5400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167613/019fc989-c2e9-754f-ba38-e04c0a3f68ed.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc989-c2e9-754f-ba38-e04c0a3f68ed",
        "storage_key": "property/6767906449167613/019fc989-c2e9-754f-ba38-e04c0a3f68ed.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJJy1sTYGPwIcRLrg-NuZcfNg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_f2a400f0-0ba2-4ec5-b0bf-180b2c43e1dc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167613",
      "source": "custom",
      "poi_name": "Primrose School of Overland Park",
      "poi_type": "Education",
      "poi_address": "12100 W 135th St, Overland Park, KS 66221, USA",
      "poi_short_description": "Warm-looking daycare with a curriculum, clean facilities and educational programs.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167613/019fc990-5032-733c-b5ad-bbfcbd2fa716.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc990-5032-733c-b5ad-bbfcbd2fa716",
        "storage_key": "property/6767906449167613/019fc990-5032-733c-b5ad-bbfcbd2fa716.webp",
        "width": 1280,
        "height": 719
      },
      "poi_business_url": "https://www.primroseschools.com/schools/overland-park/?utm_source=gbp&utm_medium=maplistings",
      "poi_directions_map_url": "https://maps.google.com/?cid=4306267260814237208&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "primrose-school-of-overland-park",
      "poi_latitude": "38.8862853",
      "poi_longitude": "-94.725953",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 913-400-2435",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167613/019fc989-c2e9-754f-ba38-e04c0a3f68ed.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc989-c2e9-754f-ba38-e04c0a3f68ed",
        "storage_key": "property/6767906449167613/019fc989-c2e9-754f-ba38-e04c0a3f68ed.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJb1EZGAfAwIcRGB66FELvwjs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "preschool"
    },
    {
      "id": "custom_a3edafe4-0c46-4fcd-bd3b-881edbbabddb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167613",
      "source": "custom",
      "poi_name": "Museum at Prairiefire",
      "poi_type": "Entertainment",
      "poi_address": "5801 W 135th St, Overland Park, KS 66223, USA",
      "poi_short_description": "Bright, uniquely designed museum with changing natural history exhibits on dinosaurs & space.",
      "poi_long_description": "Bright, uniquely designed museum with changing natural history exhibits on dinosaurs & space.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167613/019fc988-95b9-7108-a667-7f86895179ce.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc988-95b9-7108-a667-7f86895179ce",
        "storage_key": "property/6767906449167613/019fc988-95b9-7108-a667-7f86895179ce.webp",
        "width": 1170,
        "height": 797
      },
      "poi_business_url": "https://www.visitthemap.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9011883457387750483&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "museum-at-prairiefire",
      "poi_latitude": "38.8819446",
      "poi_longitude": "-94.6520905",
      "poi_miles_from_property": "5.3",
      "poi_walking_minutes": "1 hour 57 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 913-333-3500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167613/019fc989-c333-72c1-b4f2-9ea0a1978a5f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc989-c333-72c1-b4f2-9ea0a1978a5f",
        "storage_key": "property/6767906449167613/019fc989-c333-72c1-b4f2-9ea0a1978a5f.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJOdDvHPHBwIcRU-TQ6kGkEH0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_023fb9ef-57bf-4871-832f-827460dc1413",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167613",
      "source": "custom",
      "poi_name": "AMC Prairiefire 17",
      "poi_type": "Entertainment",
      "poi_address": "5724 W 136th St, Overland Park, KS 66223, USA",
      "poi_short_description": "Comfortable entertainment venue featuring a full menu alongside movie screenings of new releases.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167613/019ff6a9-7346-70a8-ac32-8620f9b80859.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6a9-7346-70a8-ac32-8620f9b80859",
        "storage_key": "property/6767906449167613/019ff6a9-7346-70a8-ac32-8620f9b80859.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.amctheatres.com/movie-theatres/kansas-city/amc-prairiefire-17?utm_medium=organic&utm_source=google&utm_campaign=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=3727223515720771879&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "amc-prairiefire-17",
      "poi_latitude": "38.8826984",
      "poi_longitude": "-94.651566",
      "poi_miles_from_property": "5.2",
      "poi_walking_minutes": "1 hour 56 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 913-553-3075",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167613/019fc994-08ee-77a1-b1f8-ed5ae641dc23.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc994-08ee-77a1-b1f8-ed5ae641dc23",
        "storage_key": "property/6767906449167613/019fc994-08ee-77a1-b1f8-ed5ae641dc23.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7fXu5_DBwIcRJ-kENQrCuTM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_2c6473fc-a959-4ff5-b83d-d7f58de96b48",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167613",
      "source": "custom",
      "poi_name": "810 Entertainment - Overland Park",
      "poi_type": "Entertainment",
      "poi_address": "13500 Nall Ave, Overland Park, KS 66224, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167613/01a0b665-b745-753f-8c34-9c238aa359f5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b665-b745-753f-8c34-9c238aa359f5",
        "storage_key": "property/6767906449167613/01a0b665-b745-753f-8c34-9c238aa359f5.webp",
        "width": 853,
        "height": 1280
      },
      "poi_business_url": "https://810bowling.com/810-entertainment-overland-park-ks",
      "poi_directions_map_url": "https://maps.google.com/?cid=11623012279752903673&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "810-entertainment---overland-park",
      "poi_latitude": "38.8828352",
      "poi_longitude": "-94.6497927",
      "poi_miles_from_property": "5.3",
      "poi_walking_minutes": "1 hour 58 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 913-600-7088",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167613/019fc989-c01a-76d7-b382-80fa5e4558ad.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc989-c01a-76d7-b382-80fa5e4558ad",
        "storage_key": "property/6767906449167613/019fc989-c01a-76d7-b382-80fa5e4558ad.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ298S-n_BwIcR-cusShY8TaE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "event_venue"
    },
    {
      "id": "custom_d6706f13-1ac1-4e9a-843c-0bf3dee53cc1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167613",
      "source": "custom",
      "poi_name": "Chicken N Pickle - Overland Park",
      "poi_type": "Restaurants",
      "poi_address": "5901 W 135th St, Overland Park, KS 66223, USA",
      "poi_short_description": "Family-friendly venue with pickleball courts and other games, plus a casual restaurant.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167613/019ff6a9-7739-769e-b362-57429ce7aea4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6a9-7739-769e-b362-57429ce7aea4",
        "storage_key": "property/6767906449167613/019ff6a9-7739-769e-b362-57429ce7aea4.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://chickennpickle.com/location/overland-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3904135511973972812&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "chicken-n-pickle---overland-park",
      "poi_latitude": "38.8830518",
      "poi_longitude": "-94.6552102",
      "poi_miles_from_property": "5.1",
      "poi_walking_minutes": "1 hour 53 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 913-703-5950",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167613/019fc989-bf42-746e-89e1-2d1abd0e4dad.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc989-bf42-746e-89e1-2d1abd0e4dad",
        "storage_key": "property/6767906449167613/019fc989-bf42-746e-89e1-2d1abd0e4dad.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJQ9D8rijBwIcRTEsyKpBGLjY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_99fb5db7-afa3-4d0a-ae29-3a69bee0ce41",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167613",
      "source": "custom",
      "poi_name": "BRKTHROUGH Overland Park",
      "poi_type": "Entertainment",
      "poi_address": "6403 W 135th St Ste E4, Overland Park, KS 66223, USA",
      "poi_short_description": "Social gaming venue at Corbin Park offering mental, physical, and skill-based challenges, plus dining.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167613/01a0b665-b818-74ef-8dd4-ce61d32195f1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b665-b818-74ef-8dd4-ce61d32195f1",
        "storage_key": "property/6767906449167613/01a0b665-b818-74ef-8dd4-ce61d32195f1.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.brkthrough.com/overland-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=18381408078784845033&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "brkthrough-overland-park",
      "poi_latitude": "38.8806486",
      "poi_longitude": "-94.659253",
      "poi_miles_from_property": "4.9",
      "poi_walking_minutes": "1 hour 50 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 913-948-5800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167613/019fc989-c01a-76d7-b382-80fa5e4558ad.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc989-c01a-76d7-b382-80fa5e4558ad",
        "storage_key": "property/6767906449167613/019fc989-c01a-76d7-b382-80fa5e4558ad.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ45a5JQXBwIcR6VR3P0LhF_8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_center"
    },
    {
      "id": "custom_9783ee97-2203-494d-b7a0-b2669638c8e3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167613",
      "source": "custom",
      "poi_name": "B&B Theatres Overland Park 16",
      "poi_type": "Entertainment",
      "poi_address": "8601 W 135th St, Overland Park, KS 66223, USA",
      "poi_short_description": "Relaxed, contemporary multiscreen theater featuring showings of mainstream films.",
      "poi_long_description": "Relaxed, contemporary multiscreen theater featuring showings of mainstream films.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167613/019fc991-770f-74cd-ba3e-e7582639fb00.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc991-770f-74cd-ba3e-e7582639fb00",
        "storage_key": "property/6767906449167613/019fc991-770f-74cd-ba3e-e7582639fb00.webp",
        "width": 1280,
        "height": 950
      },
      "poi_business_url": "https://www.bbtheatres.com/our-theatres/x0uvh-b-and-b-overland-park-16/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6259761698616561138&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bb-theatres-overland-park-16",
      "poi_latitude": "38.8812512",
      "poi_longitude": "-94.6835183",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 14 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 913-871-5352",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167613/019fc994-08ee-77a1-b1f8-ed5ae641dc23.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc994-08ee-77a1-b1f8-ed5ae641dc23",
        "storage_key": "property/6767906449167613/019fc994-08ee-77a1-b1f8-ed5ae641dc23.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJDWO_qc3BwIcR8s2iaBkk31Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_ffd71858-c2b8-4a5f-9e9e-d282b24f6e7d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167613",
      "source": "custom",
      "poi_name": "AMC Town Center 20",
      "poi_type": "Entertainment",
      "poi_address": "11701 Nall Ave, Leawood, KS 66211, USA",
      "poi_short_description": "Modern cinema equipped with comfy seats, luxury recliners, and a snack bar.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167613/019ff6a9-773d-73aa-9f03-fdcf521bbd5b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6a9-773d-73aa-9f03-fdcf521bbd5b",
        "storage_key": "property/6767906449167613/019ff6a9-773d-73aa-9f03-fdcf521bbd5b.webp",
        "width": 1280,
        "height": 783
      },
      "poi_business_url": "https://www.amctheatres.com/movie-theatres/kansas-city/amc-town-center-20?utm_medium=organic&utm_source=google&utm_campaign=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=2804340900304979407&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "amc-town-center-20",
      "poi_latitude": "38.915838",
      "poi_longitude": "-94.648325",
      "poi_miles_from_property": "5.1",
      "poi_walking_minutes": "1 hour 53 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 913-498-8696",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167613/019fc994-08ee-77a1-b1f8-ed5ae641dc23.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc994-08ee-77a1-b1f8-ed5ae641dc23",
        "storage_key": "property/6767906449167613/019fc994-08ee-77a1-b1f8-ed5ae641dc23.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6xgReh_qwIcRzwXH1zAF6yY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_f21851ae-65a4-461b-9366-69fa687fe37f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167613",
      "source": "custom",
      "poi_name": "Deanna Rose Children's Farmstead",
      "poi_type": "Entertainment",
      "poi_address": "13800 Switzer Rd, Overland Park, KS 66221, USA",
      "poi_short_description": "Spacious farmstead featuring replicas of life on the prairie, an ice cream parlor & wagon rides.",
      "poi_long_description": "Spacious farmstead featuring replicas of life on the prairie, an ice cream parlor & wagon rides.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167613/019fc990-67f7-71dc-a975-62664b346509.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc990-67f7-71dc-a975-62664b346509",
        "storage_key": "property/6767906449167613/019fc990-67f7-71dc-a975-62664b346509.webp",
        "width": 640,
        "height": 349
      },
      "poi_business_url": "http://www.opkansas.org/things-to-see-and-do/deanna-rose-childrens-farmstead/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7835830010939554497&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "deanna-rose-childrens-farmstead",
      "poi_latitude": "38.877729",
      "poi_longitude": "-94.703345",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 913-897-2360",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167613/019fc989-c01a-76d7-b382-80fa5e4558ad.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc989-c01a-76d7-b382-80fa5e4558ad",
        "storage_key": "property/6767906449167613/019fc989-c01a-76d7-b382-80fa5e4558ad.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJt6IUwjvAwIcRwbplAuF1vmw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_5b48845d-7c6f-4949-91d1-59142449cdec",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167613",
      "source": "custom",
      "poi_name": "Topgolf Overland Park",
      "poi_type": "Restaurants",
      "poi_address": "10611 Nall Ave, Overland Park, KS 66207, USA",
      "poi_short_description": "Sprawling entertainment venue with a high-tech driving range & swanky lounge with drinks & games.",
      "poi_long_description": "Sprawling entertainment venue with a high-tech driving range & swanky lounge with drinks & games.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167613/019fc988-87ee-750b-be5e-e1eacd3ea600.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc988-87ee-750b-be5e-e1eacd3ea600",
        "storage_key": "property/6767906449167613/019fc988-87ee-750b-be5e-e1eacd3ea600.webp",
        "width": 1280,
        "height": 884
      },
      "poi_business_url": "https://topgolf.com/us/overland-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4737452325202402593&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "topgolf-overland-park",
      "poi_latitude": "38.9364597",
      "poi_longitude": "-94.64818",
      "poi_miles_from_property": "6.2",
      "poi_walking_minutes": "2 hours 18 mins",
      "poi_biking_minutes": "48 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 913-562-9713",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167613/019fc989-bf42-746e-89e1-2d1abd0e4dad.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc989-bf42-746e-89e1-2d1abd0e4dad",
        "storage_key": "property/6767906449167613/019fc989-bf42-746e-89e1-2d1abd0e4dad.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJibz1RyvqwIcRIZ0JKMrPvkE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_6fd1c9ad-a3b3-43e0-a22d-c85a7f3a8308",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167613",
      "source": "custom",
      "poi_name": "Overland Park Arboretum & Botanical Gardens",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "8909 W 179th St, Overland Park, KS 66013, USA",
      "poi_short_description": "Gardens, trails & recreation areas plus educational programs & events on environmental issues.",
      "poi_long_description": "Gardens, trails & recreation areas plus educational programs & events on environmental issues.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167613/019ff6a9-79a0-711d-9f04-bb8919cb1643.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6a9-79a0-711d-9f04-bb8919cb1643",
        "storage_key": "property/6767906449167613/019ff6a9-79a0-711d-9f04-bb8919cb1643.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.opkansas.org/recreation-fun/arboretum-botanical-gardens/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8713039177416778041&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "overland-park-arboretum--botanical-gardens",
      "poi_latitude": "38.8033925",
      "poi_longitude": "-94.6891159",
      "poi_miles_from_property": "8.5",
      "poi_walking_minutes": "3 hours 6 mins",
      "poi_biking_minutes": "50 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 913-685-3604",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167613/019fc989-c01a-76d7-b382-80fa5e4558ad.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc989-c01a-76d7-b382-80fa5e4558ad",
        "storage_key": "property/6767906449167613/019fc989-c01a-76d7-b382-80fa5e4558ad.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6csjvynHwIcROSH92_fu6ng",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "botanical_garden"
    },
    {
      "id": "custom_3dfcfc94-bce1-45e3-9687-bf79fd3e30d6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167613",
      "source": "custom",
      "poi_name": "Overland Park Regional Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "10500 Quivira Rd, Overland Park, KS 66215, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167613/019fc993-00d6-7698-b992-29cf154f99b7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc993-00d6-7698-b992-29cf154f99b7",
        "storage_key": "property/6767906449167613/019fc993-00d6-7698-b992-29cf154f99b7.webp",
        "width": 1280,
        "height": 719
      },
      "poi_business_url": "https://www.hcamidwest.com/locations/overland-park-regional-medical-center?utm_campaign=corp_listings_mgmt&utm_source=google&utm_medium=business_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=13555409796355494155&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "overland-park-regional-medical-center",
      "poi_latitude": "38.9376197",
      "poi_longitude": "-94.7261812",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 913-541-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167613/019fc989-c2de-7023-b3b2-ef7a88cd9011.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc989-c2de-7023-b3b2-ef7a88cd9011",
        "storage_key": "property/6767906449167613/019fc989-c2de-7023-b3b2-ef7a88cd9011.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4cFCWJzAwIcRC5Ge4GN9Hrw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_d8491d53-f10f-4ea3-b581-52b90be81ed5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167613",
      "source": "custom",
      "poi_name": "Phoenix HealthCare Clinic",
      "poi_type": "Health and Wellness",
      "poi_address": "11029 Hauser St, Lenexa, KS 66210, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167613/019ff6a9-7be3-70fe-a25c-9a882ff9428f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6a9-7be3-70fe-a25c-9a882ff9428f",
        "storage_key": "property/6767906449167613/019ff6a9-7be3-70fe-a25c-9a882ff9428f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://phoenixhcc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2113498401335006626&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "phoenix-healthcare-clinic",
      "poi_latitude": "38.9290285",
      "poi_longitude": "-94.7380639",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "1 hour 0 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 913-851-0500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167613/019fc989-c01a-76d7-b382-80fa5e4558ad.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc989-c01a-76d7-b382-80fa5e4558ad",
        "storage_key": "property/6767906449167613/019fc989-c01a-76d7-b382-80fa5e4558ad.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJbT8yyLXqwIcRotXtJJmnVB0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_c35a31d1-9b6a-41a2-af6c-a8e87d9cb8cc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167613",
      "source": "custom",
      "poi_name": "Capstone Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "11844 Quivira Rd, Overland Park, KS 66210, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167613/019ff6a9-6f68-7268-b2e2-bb5a616c650f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6a9-6f68-7268-b2e2-bb5a616c650f",
        "storage_key": "property/6767906449167613/019ff6a9-6f68-7268-b2e2-bb5a616c650f.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.capstone-rx.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3304926522333783525&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "capstone-pharmacy",
      "poi_latitude": "38.9135078",
      "poi_longitude": "-94.7243329",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 913-346-7405",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167613/019fc994-08ee-77a1-b1f8-ebf2d02bf56f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc994-08ee-77a1-b1f8-ebf2d02bf56f",
        "storage_key": "property/6767906449167613/019fc994-08ee-77a1-b1f8-ebf2d02bf56f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJERv5hMPvwIcR5eV4bCl13S0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_78374136-88f3-42ad-af73-b4a3db98baac",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167613",
      "source": "custom",
      "poi_name": "Stark Edler Apothecary",
      "poi_type": "Health and Wellness",
      "poi_address": "10600 S Quivira Rd #100, Overland Park, KS 66215, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://starkapothecary.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1454330977971285722&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "stark-edler-apothecary",
      "poi_latitude": "38.9361746",
      "poi_longitude": "-94.7254118",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "56 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 913-541-5050",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167613/019fc994-08ee-77a1-b1f8-ebf2d02bf56f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc994-08ee-77a1-b1f8-ebf2d02bf56f",
        "storage_key": "property/6767906449167613/019fc994-08ee-77a1-b1f8-ebf2d02bf56f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5T1J-CrrwIcR2i7Tr1HSLhQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_4c52264f-dee3-4159-aafd-d85b7ee3eeca",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167613",
      "source": "custom",
      "poi_name": "CVS",
      "poi_type": "Health and Wellness",
      "poi_address": "12290 College Blvd, Overland Park, KS 66210, USA",
      "poi_short_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_long_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167613/01a0b665-c10a-7208-b199-48a2aa5cc0ac.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b665-c10a-7208-b199-48a2aa5cc0ac",
        "storage_key": "property/6767906449167613/01a0b665-c10a-7208-b199-48a2aa5cc0ac.webp",
        "width": 1280,
        "height": 493
      },
      "poi_business_url": "https://www.cvs.com/store-locator/overland-park-ks-pharmacies/12290-w-college-blvd-overland-park-ks-66210/storeid=8601?WT.mc_id=LS_GOOGLE_FS_8601",
      "poi_directions_map_url": "https://maps.google.com/?cid=2998230267302422273&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs",
      "poi_latitude": "38.92859",
      "poi_longitude": "-94.72835",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "47 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 913-327-1332",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167613/019fc989-c01a-76d7-b382-80fa5e4558ad.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc989-c01a-76d7-b382-80fa5e4558ad",
        "storage_key": "property/6767906449167613/019fc989-c01a-76d7-b382-80fa5e4558ad.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJt4BBpyyVwIcRAadi9Yramyk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "custom_3b7beb8d-a246-4d0a-967f-486c203acd9d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167613",
      "source": "custom",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "7501 Metcalf Ave, Overland Park, KS 66204, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167613/01a0b665-c0a7-706f-bc20-43e5d7aef108.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b665-c0a7-706f-bc20-43e5d7aef108",
        "storage_key": "property/6767906449167613/01a0b665-c0a7-706f-bc20-43e5d7aef108.webp",
        "width": 720,
        "height": 481
      },
      "poi_business_url": "https://www.cvs.com/store-locator/overland-park-ks-pharmacies/7501-metcalf-ave-overland-park-ks-66204/storeid=8602?WT.mc_id=LS_GOOGLE_RX_8602",
      "poi_directions_map_url": "https://maps.google.com/?cid=11913304384597097063&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "38.99266",
      "poi_longitude": "-94.66672",
      "poi_miles_from_property": "8.6",
      "poi_walking_minutes": "3 hours 12 mins",
      "poi_biking_minutes": "58 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 913-642-6330",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167613/019fc994-08ee-77a1-b1f8-ebf2d02bf56f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc994-08ee-77a1-b1f8-ebf2d02bf56f",
        "storage_key": "property/6767906449167613/019fc994-08ee-77a1-b1f8-ebf2d02bf56f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJXz_FvmzswIcRZ3oD6TePVKU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_6b10b40b-e5fd-4c33-bc9b-d2d7ee9d0c7a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167613",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "9331 Quivira Rd, Overland Park, KS 66215, USA",
      "poi_short_description": "Friendly chain gym offering treadmills and other equipment, plus classes.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167613/019fc988-a61a-70c8-8dfa-8d75e75571fc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc988-a61a-70c8-8dfa-8d75e75571fc",
        "storage_key": "property/6767906449167613/019fc988-a61a-70c8-8dfa-8d75e75571fc.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/overland-park-93rd-quivira-ks?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=9830202165263287199&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "38.9596389",
      "poi_longitude": "-94.7231493",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 32 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 913-717-6070",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167613/019fc989-c01a-76d7-b382-80fa5e4558ad.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc989-c01a-76d7-b382-80fa5e4558ad",
        "storage_key": "property/6767906449167613/019fc989-c01a-76d7-b382-80fa5e4558ad.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJA3RFIs6UwIcRn0PLYsnka4g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_1791b5eb-f925-40a2-b612-b24a8812416e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167613",
      "source": "custom",
      "poi_name": "THRIVE Training",
      "poi_type": "Health and Wellness",
      "poi_address": "9201 W 133rd St, Overland Park, KS 66213, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://thrivefittrain.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14737326533533193770&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "thrive-training",
      "poi_latitude": "38.8857204",
      "poi_longitude": "-94.6935867",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "1 hour 0 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167613/019fc989-c01a-76d7-b382-80fa5e4558ad.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc989-c01a-76d7-b382-80fa5e4558ad",
        "storage_key": "property/6767906449167613/019fc989-c01a-76d7-b382-80fa5e4558ad.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJJfGEtp_BwIcRKlYvimaAhcw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_98d62db3-da3f-4eb9-9ba7-241a6587e290",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167613",
      "source": "custom",
      "poi_name": "YogaSix",
      "poi_type": "Health and Wellness",
      "poi_address": "6555 W 119th St, Overland Park, KS 66209, USA",
      "poi_short_description": "Relaxed yoga studio offering a variety of classes including hot and restorative types, plus a shop selling yoga apparel.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167613/019fc991-7083-764d-ab39-144fae474d5a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc991-7083-764d-ab39-144fae474d5a",
        "storage_key": "property/6767906449167613/019fc991-7083-764d-ab39-144fae474d5a.webp",
        "width": 554,
        "height": 312
      },
      "poi_business_url": "https://www.yogasix.com/overland-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=4666487347789615135&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "yogasix",
      "poi_latitude": "38.9124848",
      "poi_longitude": "-94.6603913",
      "poi_miles_from_property": "4.3",
      "poi_walking_minutes": "1 hour 35 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 913-660-9230",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167613/019fc989-c2e9-754f-ba38-e04c0a3f68ed.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc989-c2e9-754f-ba38-e04c0a3f68ed",
        "storage_key": "property/6767906449167613/019fc989-c2e9-754f-ba38-e04c0a3f68ed.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJkS5c-rTrwIcRH9DayYSxwkA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "yoga_studio"
    },
    {
      "id": "custom_5e23684c-4efc-40f4-825c-f6aca15fbc71",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167613",
      "source": "custom",
      "poi_name": "The J KC - Jewish Community Center",
      "poi_type": "Entertainment",
      "poi_address": "5801 W 115th St, Overland Park, KS 66211, USA",
      "poi_short_description": "Fitness facilities featuring an outdoor pool and a children’s zero-depth area, along with summer camps.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167613/01a0b665-c299-72cc-967d-5e44e1977874.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b665-c299-72cc-967d-5e44e1977874",
        "storage_key": "property/6767906449167613/01a0b665-c299-72cc-967d-5e44e1977874.webp",
        "width": 1280,
        "height": 644
      },
      "poi_business_url": "https://www.thejkc.org/?utm_source=gbp&utm_medium=organic&utm_id=ifocus",
      "poi_directions_map_url": "https://maps.google.com/?cid=7379659872118781108&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-j-kc---jewish-community-center",
      "poi_latitude": "38.9189183",
      "poi_longitude": "-94.6527131",
      "poi_miles_from_property": "5.1",
      "poi_walking_minutes": "1 hour 54 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 913-327-8000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167613/019fc989-c01a-76d7-b382-80fa5e4558ad.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc989-c01a-76d7-b382-80fa5e4558ad",
        "storage_key": "property/6767906449167613/019fc989-c01a-76d7-b382-80fa5e4558ad.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJtaeWVyLqwIcRtDTY-I3RaWY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "community_center"
    },
    {
      "id": "custom_5f210715-8a60-4538-ac40-c6b6d5597898",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167613",
      "source": "custom",
      "poi_name": "Quivira Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "11901 Quivira Rd, Overland Park, KS 66213, USA",
      "poi_short_description": "Small community park featuring a playground, picnic tables & 2 sand volleyball courts.",
      "poi_long_description": "Small community park featuring a playground, picnic tables & 2 sand volleyball courts.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167613/019ff6a9-834b-76cb-9b99-1ea60dd3f830.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6a9-834b-76cb-9b99-1ea60dd3f830",
        "storage_key": "property/6767906449167613/019ff6a9-834b-76cb-9b99-1ea60dd3f830.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.opkansas.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17176832562132200599&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "quivira-park",
      "poi_latitude": "38.9107813",
      "poi_longitude": "-94.7229342",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "14 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 913-895-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167613/019fc989-c338-7195-8ee5-1d090c997c33.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc989-c338-7195-8ee5-1d090c997c33",
        "storage_key": "property/6767906449167613/019fc989-c338-7195-8ee5-1d090c997c33.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJmbS_K7TqwIcRl6xAYDVeYO4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_8a226fa2-d405-4e17-bf63-26e8a54b9ae5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167613",
      "source": "custom",
      "poi_name": "Thomas S. Stoll Memorial Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "12500 W 119th St, Overland Park, KS 66210, USA",
      "poi_short_description": "Public 79-acre park with 7 ball fields, a fishing lake, a playground & a scenic nature trail.",
      "poi_long_description": "Public 79-acre park with 7 ball fields, a fishing lake, a playground & a scenic nature trail.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167613/019ff6a9-859f-75d8-8684-2c168a6113b1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6a9-859f-75d8-8684-2c168a6113b1",
        "storage_key": "property/6767906449167613/019ff6a9-859f-75d8-8684-2c168a6113b1.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.jcprd.com/parks_facilities/stoll_park.cfm",
      "poi_directions_map_url": "https://maps.google.com/?cid=11904290777782419563&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "thomas-s-stoll-memorial-park",
      "poi_latitude": "38.9133269",
      "poi_longitude": "-94.7313061",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 913-438-7275",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167613/019fc989-c338-7195-8ee5-1d090c997c33.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc989-c338-7195-8ee5-1d090c997c33",
        "storage_key": "property/6767906449167613/019fc989-c338-7195-8ee5-1d090c997c33.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ06uvXjSVwIcRawCuCGSJNKU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_4be6f569-7538-4701-bf17-14c7ca4e43cb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167613",
      "source": "custom",
      "poi_name": "Nall Hills Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "5501 Indian Creek Dr, Overland Park, KS 66207, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167613/01a0b666-005a-710c-b3be-8b977b760777.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b666-005a-710c-b3be-8b977b760777",
        "storage_key": "property/6767906449167613/01a0b666-005a-710c-b3be-8b977b760777.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.opkansas.org/park/nall-hills-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15640790860681485836&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "nall-hills-park",
      "poi_latitude": "38.938963",
      "poi_longitude": "-94.651414",
      "poi_miles_from_property": "6.3",
      "poi_walking_minutes": "2 hours 17 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 913-895-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167613/019fc989-c338-7195-8ee5-1d090c997c33.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc989-c338-7195-8ee5-1d090c997c33",
        "storage_key": "property/6767906449167613/019fc989-c338-7195-8ee5-1d090c997c33.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_3cm1f7rwIcRDJ4YWWtAD9k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_36da5c5a-21a6-4e1d-93ae-23d3634f3932",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167613",
      "source": "custom",
      "poi_name": "Roe Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "10400 Roe Ave, Overland Park, KS 66207, USA",
      "poi_short_description": "40-acre green space boasting a swimming pool, sports courts, a playground & hiking/biking trails.",
      "poi_long_description": "40-acre green space boasting a swimming pool, sports courts, a playground & hiking/biking trails.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167613/019fc988-c7b0-74ae-b5b9-768fcd60c6af.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc988-c7b0-74ae-b5b9-768fcd60c6af",
        "storage_key": "property/6767906449167613/019fc988-c7b0-74ae-b5b9-768fcd60c6af.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.opkansas.org/park/roe-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5745814544235702059&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "roe-park",
      "poi_latitude": "38.939606",
      "poi_longitude": "-94.6420669",
      "poi_miles_from_property": "7",
      "poi_walking_minutes": "2 hours 33 mins",
      "poi_biking_minutes": "48 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 913-895-6390",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167613/019fc989-c338-7195-8ee5-1d090c997c33.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc989-c338-7195-8ee5-1d090c997c33",
        "storage_key": "property/6767906449167613/019fc989-c338-7195-8ee5-1d090c997c33.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJHWhkHX_pwIcRKydxpuI7vU8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_d8e47841-0242-46af-8c17-0c0ad69753c7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167613",
      "source": "custom",
      "poi_name": "South Lake Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "7601 W 86th St, Overland Park, KS 66212, USA",
      "poi_short_description": "This 14-acre park features a playground, a trail, a fishing lake, basketball, restrooms & more.",
      "poi_long_description": "This 14-acre park features a playground, a trail, a fishing lake, basketball, restrooms & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167613/01a0b665-cbb2-7799-97d2-009a15804d1d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b665-cbb2-7799-97d2-009a15804d1d",
        "storage_key": "property/6767906449167613/01a0b665-cbb2-7799-97d2-009a15804d1d.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.opkansas.org/things-to-see-and-do/parks/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9828798773383756620&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "south-lake-park",
      "poi_latitude": "38.9725",
      "poi_longitude": "-94.6738889",
      "poi_miles_from_property": "7.3",
      "poi_walking_minutes": "2 hours 43 mins",
      "poi_biking_minutes": "53 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 913-895-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167613/019fc989-c338-7195-8ee5-1d090c997c33.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc989-c338-7195-8ee5-1d090c997c33",
        "storage_key": "property/6767906449167613/019fc989-c338-7195-8ee5-1d090c997c33.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJdSu1Ko_rwIcRTHtVwGjoZog",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_c0a83cf8-806c-4896-8e9c-f31a0eb73b73",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167613",
      "source": "custom",
      "poi_name": "Leawood City Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "10601 Lee Blvd, Leawood, KS 66206, USA",
      "poi_short_description": "Public park with a playground, trails, pool, tennis courts, sports fields, and an off-leash area for dogs.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167613/01a0b665-d1e9-709a-b4e0-ce7ce7fc8e2f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b665-d1e9-709a-b4e0-ce7ce7fc8e2f",
        "storage_key": "property/6767906449167613/01a0b665-d1e9-709a-b4e0-ce7ce7fc8e2f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.leawood.org",
      "poi_directions_map_url": "https://maps.google.com/?cid=11472992157373923685&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "leawood-city-park",
      "poi_latitude": "38.9308908",
      "poi_longitude": "-94.6190568",
      "poi_miles_from_property": "7.3",
      "poi_walking_minutes": "2 hours 40 mins",
      "poi_biking_minutes": "56 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 913-339-6700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167613/019fc989-c338-7195-8ee5-1d090c997c33.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc989-c338-7195-8ee5-1d090c997c33",
        "storage_key": "property/6767906449167613/019fc989-c338-7195-8ee5-1d090c997c33.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_1CEy6XpwIcRZYEdo5RBOJ8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_65ba8376-a0fd-4888-8c5e-e30515b7317a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167613",
      "source": "custom",
      "poi_name": "Ernie Miller Park & Nature Center",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "909 North, KS-7, Olathe, KS 66061, USA",
      "poi_short_description": "116-acre nature preserve featuring trails & an education center with animals, exhibits & programs.",
      "poi_long_description": "116-acre nature preserve featuring trails & an education center with animals, exhibits & programs.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167613/019ff6a9-85a5-761a-9323-e93f91a3c9e8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6a9-85a5-761a-9323-e93f91a3c9e8",
        "storage_key": "property/6767906449167613/019ff6a9-85a5-761a-9323-e93f91a3c9e8.webp",
        "width": 1000,
        "height": 664
      },
      "poi_business_url": "http://erniemiller.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5769145388029025309&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ernie-miller-park--nature-center",
      "poi_latitude": "38.8967913",
      "poi_longitude": "-94.8409835",
      "poi_miles_from_property": "6.5",
      "poi_walking_minutes": "2 hours 26 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 913-826-2800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167613/019fc989-c338-7195-8ee5-1d090c997c33.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc989-c338-7195-8ee5-1d090c997c33",
        "storage_key": "property/6767906449167613/019fc989-c338-7195-8ee5-1d090c997c33.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJt22HnSWWwIcRHZwNByofEFA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "nature_preserve"
    },
    {
      "id": "custom_a4905155-8a8f-4260-af6e-25a46a5ee700",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167613",
      "source": "custom",
      "poi_name": "Mahaffie Stagecoach Stop-Farm",
      "poi_type": "Entertainment",
      "poi_address": "1200 E Kansas City Rd, Olathe, KS 66061, USA",
      "poi_short_description": "19th-century farm & living history museum with historic reenactments & era–specific activities.",
      "poi_long_description": "19th-century farm & living history museum with historic reenactments & era–specific activities.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167613/019ff6a9-859a-7327-aaa0-b87c42c6ccb6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6a9-859a-7327-aaa0-b87c42c6ccb6",
        "storage_key": "property/6767906449167613/019ff6a9-859a-7327-aaa0-b87c42c6ccb6.webp",
        "width": 1200,
        "height": 965
      },
      "poi_business_url": "http://www.mahaffie.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4906880325698000129&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mahaffie-stagecoach-stop-farm",
      "poi_latitude": "38.8920954",
      "poi_longitude": "-94.7996569",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 39 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 913-971-5111",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167613/019fc989-c333-72c1-b4f2-9ea0a1978a5f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc989-c333-72c1-b4f2-9ea0a1978a5f",
        "storage_key": "property/6767906449167613/019fc989-c333-72c1-b4f2-9ea0a1978a5f.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5f59bfeVwIcRARWVkKi9GEQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_3c24a5a7-fc2b-470f-b514-80405249a957",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167613",
      "source": "custom",
      "poi_name": "On Quivira Between 118th and 119th St Southbound",
      "poi_type": "Transportation & Transit",
      "poi_address": "Overland Park, KS 66210, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=11027092951262941056&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "on-quivira-between-118th-and-119th-st-southbound",
      "poi_latitude": "38.913562",
      "poi_longitude": "-94.723874",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167613/019ff6a9-9549-7399-b515-92d67be910b2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a9-9549-7399-b515-92d67be910b2",
        "storage_key": "property/6767906449167613/019ff6a9-9549-7399-b515-92d67be910b2.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJKfhUC8rqwIcRgM89eZ0aCJk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "custom_c3344d11-4b55-4586-b23b-a9a6558ac5b2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167613",
      "source": "custom",
      "poi_name": "Oak Park Mall Park and Ride",
      "poi_type": "Transportation & Transit",
      "poi_address": "Overland Park, KS 66214, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=13146997606835839132&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "oak-park-mall-park-and-ride",
      "poi_latitude": "38.954938",
      "poi_longitude": "-94.715914",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 33 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167613/019fc994-08f7-775c-9b85-e0345235a440.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc994-08f7-775c-9b85-e0345235a440",
        "storage_key": "property/6767906449167613/019fc994-08f7-775c-9b85-e0345235a440.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJv9bmcDjrwIcRnGBc6qqEc7Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_station"
    },
    {
      "id": "custom_960099f8-0673-4ccf-bad3-83b265df7d91",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167613",
      "source": "custom",
      "poi_name": "Metcalf Nail Lounge",
      "poi_type": "Health and Wellness",
      "poi_address": "7424 W 121st St, Overland Park, KS 66213, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167613/01a0b665-f88a-7702-bc08-79b21a0bf169.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0b665-f88a-7702-bc08-79b21a0bf169",
        "storage_key": "property/6767906449167613/01a0b665-f88a-7702-bc08-79b21a0bf169.webp",
        "width": 1280,
        "height": 1048
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=11949742681397912184&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "metcalf-nail-lounge",
      "poi_latitude": "38.90831379999999",
      "poi_longitude": "-94.6703975",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 27 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 913-469-6245",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167613/019fc989-c01a-76d7-b382-80fa5e4558ad.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc989-c01a-76d7-b382-80fa5e4558ad",
        "storage_key": "property/6767906449167613/019fc989-c01a-76d7-b382-80fa5e4558ad.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJiVu4MWzqwIcReOILAqgD1qU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "nail_salon"
    },
    {
      "id": "custom_86644fc6-9478-44c4-a93c-c528f6f053f8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167613",
      "source": "custom",
      "poi_name": "Strang Line Road Park and Ride",
      "poi_type": "Transportation & Transit",
      "poi_address": "Olathe, KS 66062, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=3436547488501433531&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "strang-line-road-park-and-ride",
      "poi_latitude": "38.9082495",
      "poi_longitude": "-94.774183",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 17 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167613/019ff6a9-9549-7399-b515-92d67be910b2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a9-9549-7399-b515-92d67be910b2",
        "storage_key": "property/6767906449167613/019ff6a9-9549-7399-b515-92d67be910b2.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJI1GA1J6VwIcRu4TjsbsRsS8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "custom_c597af3c-0e3e-4543-99c9-7d1637b9c2b6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167613",
      "source": "custom",
      "poi_name": "Mission Transit Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "5251 Johnson Dr, Roeland Park, KS 66205, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://ridekc.org/locations/mission_transit_center",
      "poi_directions_map_url": "https://maps.google.com/?cid=14750820283784844061&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mission-transit-center",
      "poi_latitude": "39.0229186",
      "poi_longitude": "-94.6460432",
      "poi_miles_from_property": "11.5",
      "poi_walking_minutes": "4 hours 15 mins",
      "poi_biking_minutes": "1 hour 15 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167613/019fc994-08ee-77a1-b1f8-f3c8fe9321be.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc994-08ee-77a1-b1f8-f3c8fe9321be",
        "storage_key": "property/6767906449167613/019fc994-08ee-77a1-b1f8-f3c8fe9321be.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0RGVf9XtwIcRHVOfGOVwtcw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "parking_lot"
    },
    {
      "id": "custom_99e9b013-d361-4ff3-aeb8-317b8b049ae1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167613",
      "source": "custom",
      "poi_name": "Kansas City International Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "1 Kansas City Blvd, Kansas City, MO 64153, USA",
      "poi_short_description": "Airport featuring domestic & global flights plus free WiFi & a variety of eateries.",
      "poi_long_description": "Airport featuring domestic & global flights plus free WiFi & a variety of eateries.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167613/019fc992-cf47-72ab-bf8c-00300ff2ef99.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc992-cf47-72ab-bf8c-00300ff2ef99",
        "storage_key": "property/6767906449167613/019fc992-cf47-72ab-bf8c-00300ff2ef99.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "http://www.flykc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14109162014977743520&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kansas-city-international-airport",
      "poi_latitude": "39.3013901",
      "poi_longitude": "-94.7104232",
      "poi_miles_from_property": "39.2",
      "poi_walking_minutes": "14 hours 34 mins",
      "poi_biking_minutes": "4 hours 23 mins",
      "poi_driving_minutes": "39 mins",
      "poi_business_phone": "+1 816-243-5237",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167613/019fc989-c923-71e1-8481-3108e8f71288.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc989-c923-71e1-8481-3108e8f71288",
        "storage_key": "property/6767906449167613/019fc989-c923-71e1-8481-3108e8f71288.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJmYfmiAhewIcRoNouXRnQzcM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "international_airport"
    },
    {
      "id": "custom_be2bb294-5042-4bea-9d50-ee1da048e6a8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167613",
      "source": "custom",
      "poi_name": "T-Mobile Corporate Office",
      "poi_type": "Major Employers & Offices",
      "poi_address": "6220 Sprint Pkwy, Overland Park, KS 66211, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167613/019fc989-0cc3-76ab-ad67-a95d31af7faf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc989-0cc3-76ab-ad67-a95d31af7faf",
        "storage_key": "property/6767906449167613/019fc989-0cc3-76ab-ad67-a95d31af7faf.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=16065491002476993060&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "t-mobile-corporate-office",
      "poi_latitude": "38.9149922",
      "poi_longitude": "-94.6573794",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 45 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 855-977-5086",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167613/019fc989-c01a-76d7-b382-80fa5e4558ad.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc989-c01a-76d7-b382-80fa5e4558ad",
        "storage_key": "property/6767906449167613/019fc989-c01a-76d7-b382-80fa5e4558ad.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJI0P_xjzrwIcRJBrguPIW9N4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_b3de0979-5211-40bd-95ec-68ac9fa47fe6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167613",
      "source": "custom",
      "poi_name": "Black & Veatch",
      "poi_type": "Major Employers & Offices",
      "poi_address": "11401 Lamar Ave, Overland Park, KS 66211, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167613/019fc992-e7e2-776e-b6e5-9197128181f4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc992-e7e2-776e-b6e5-9197128181f4",
        "storage_key": "property/6767906449167613/019fc992-e7e2-776e-b6e5-9197128181f4.webp",
        "width": 1280,
        "height": 653
      },
      "poi_business_url": "http://www.bv.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15245877116558125981&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "black--veatch",
      "poi_latitude": "38.9250015",
      "poi_longitude": "-94.6553624",
      "poi_miles_from_property": "5.1",
      "poi_walking_minutes": "1 hour 53 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 913-458-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167613/019fc989-c01a-76d7-b382-80fa5e4558ad.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc989-c01a-76d7-b382-80fa5e4558ad",
        "storage_key": "property/6767906449167613/019fc989-c01a-76d7-b382-80fa5e4558ad.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJUyTe2TrqwIcRnSu0HXY8lNM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "consultant"
    },
    {
      "id": "custom_eb697c93-a724-48f3-8ed5-7b85c770c387",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167613",
      "source": "custom",
      "poi_name": "Children's Mercy Kansas",
      "poi_type": "Health and Wellness",
      "poi_address": "5808 W 110th St, Overland Park, KS 66211, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167613/019fc988-af84-705f-9fee-5915539337e3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc988-af84-705f-9fee-5915539337e3",
        "storage_key": "property/6767906449167613/019fc988-af84-705f-9fee-5915539337e3.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "https://www.childrensmercy.org/Kansas/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8535209985424805612&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "childrens-mercy-kansas",
      "poi_latitude": "38.9299718",
      "poi_longitude": "-94.6522904",
      "poi_miles_from_property": "5.6",
      "poi_walking_minutes": "2 hours 4 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 913-696-8000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167613/019fc989-c2de-7023-b3b2-ef7a88cd9011.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc989-c2de-7023-b3b2-ef7a88cd9011",
        "storage_key": "property/6767906449167613/019fc989-c2de-7023-b3b2-ef7a88cd9011.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ03Xo8C7qwIcR7M6coEIoc3Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_cbc3d095-6891-4750-902c-93ba8ac64ca7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167613",
      "source": "custom",
      "poi_name": "Saint Luke's South Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "12300 Metcalf Ave, Overland Park, KS 66213, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167613/019fc991-0c80-7683-bfe5-1781ce2d532d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc991-0c80-7683-bfe5-1781ce2d532d",
        "storage_key": "property/6767906449167613/019fc991-0c80-7683-bfe5-1781ce2d532d.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.saintlukeskc.org/locations/saint-lukes-south-hospital?utm_source=local-listing&utm_medium=organic&utm_campaign=website-link",
      "poi_directions_map_url": "https://maps.google.com/?cid=8966224544508452770&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "saint-lukes-south-hospital",
      "poi_latitude": "38.9041982",
      "poi_longitude": "-94.6695167",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 32 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 913-317-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167613/019fc989-c2de-7023-b3b2-ef7a88cd9011.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc989-c2de-7023-b3b2-ef7a88cd9011",
        "storage_key": "property/6767906449167613/019fc989-c2de-7023-b3b2-ef7a88cd9011.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJkT2aF3LqwIcRop_Q17dtbnw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "general_hospital"
    },
    {
      "id": "custom_14f59745-9f3c-4e1c-82f0-eec9c26b3484",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167613",
      "source": "custom",
      "poi_name": "Cboe Global Markets, Inc.",
      "poi_type": "Major Employers & Offices",
      "poi_address": "6800 W 115th St Ste 260, Overland Park, KS 66211, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.cboe.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17686344054008590658&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cboe-global-markets-inc",
      "poi_latitude": "38.9188074",
      "poi_longitude": "-94.6621682",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 42 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 913-815-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167613/019fc989-c01a-76d7-b382-80fa5e4558ad.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc989-c01a-76d7-b382-80fa5e4558ad",
        "storage_key": "property/6767906449167613/019fc989-c01a-76d7-b382-80fa5e4558ad.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJR5KGSqLswIcRQjGG-jWEcvU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "finance"
    },
    {
      "id": "custom_bb7a4f61-f1e4-413a-86f1-65683cfa7d4e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167613",
      "source": "custom",
      "poi_name": "Menorah Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "5721 W 119th St, Overland Park, KS 66209, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167613/019fc988-c7ff-7653-b4f1-1887f77a0a90.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc988-c7ff-7653-b4f1-1887f77a0a90",
        "storage_key": "property/6767906449167613/019fc988-c7ff-7653-b4f1-1887f77a0a90.webp",
        "width": 1280,
        "height": 983
      },
      "poi_business_url": "https://www.hcamidwest.com/locations/menorah-medical-center?utm_campaign=corp_listings_mgmt&utm_source=google&utm_medium=business_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=13288974551408218760&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "menorah-medical-center",
      "poi_latitude": "38.9108041",
      "poi_longitude": "-94.6515422",
      "poi_miles_from_property": "4.9",
      "poi_walking_minutes": "1 hour 48 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 913-498-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167613/019fc989-c2de-7023-b3b2-ef7a88cd9011.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc989-c2de-7023-b3b2-ef7a88cd9011",
        "storage_key": "property/6767906449167613/019fc989-c2de-7023-b3b2-ef7a88cd9011.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJa9T6FxnqwIcRiJLkTfLra7g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "general_hospital"
    },
    {
      "id": "custom_5b684ed2-8eba-4fc5-9d6f-11fd9454fd96",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167613",
      "source": "custom",
      "poi_name": "Garmin",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1200 E 151st St, Olathe, KS 66062, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167613/019fc988-f74f-7031-9bff-35b4dcd89f0b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc988-f74f-7031-9bff-35b4dcd89f0b",
        "storage_key": "property/6767906449167613/019fc988-f74f-7031-9bff-35b4dcd89f0b.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.garmin.com/en-US",
      "poi_directions_map_url": "https://maps.google.com/?cid=7856958804647333168&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "garmin",
      "poi_latitude": "38.8553721",
      "poi_longitude": "-94.7996464",
      "poi_miles_from_property": "6.5",
      "poi_walking_minutes": "2 hours 23 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 800-800-1020",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167613/019fc989-c01a-76d7-b382-80fa5e4558ad.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc989-c01a-76d7-b382-80fa5e4558ad",
        "storage_key": "property/6767906449167613/019fc989-c01a-76d7-b382-80fa5e4558ad.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJmdY73mS-wIcRMM3hpWeGCW0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    }
  ],
  "office_hours": [
    {
      "id": "ec_2775d7b650baceb27d5722ef",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167613",
      "day": "MON",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_626c43563248ed9f6821452b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167613",
      "day": "TUE",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_4286dd3ad277488d71cedd1d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167613",
      "day": "WED",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_054d9181be80e22b752d31ba",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167613",
      "day": "THU",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_ebb686b0236e361118bc7605",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167613",
      "day": "FRI",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_a8b1d6478469362cda544089",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167613",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "ec_ca0cf210e87e70230e795a37",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167613",
      "rating": "5",
      "name": "Cassie Whelchel",
      "text": "When I found Stonebriar Apartments, I had been looking for an apartment for many months. I had just moved to Kansas from Missouri and I kind of knew what I wanted, but I just hadn’t found it yet. Walk into the leasing office and saw Miss Cindy sitting at her desk and and she asked me if she could help me. I told her my budget and she Went to work looking then she took me to see The first apartment of which is the one I currently live in. I did not want upstairs, but after she showed it to me, I fell in love. All the natural light all the windows, the square footage bedroom, bedrooms, bathrooms everything was just perfect including a fireplace which I dearly wanted. Miss Cindy was so thrilled along with me when she found this and it was just what I wanted she’s a precious person. Excellent personality and I love her to death. It’s a great community. It’s beautiful grounds. Great location you couldn’t ask for anymore. I appreciate her very much and I’ve made a new friend in the process.",
      "date": "2026-04-18",
      "title": "false"
    },
    {
      "id": "ec_97fded6200a9c7dcb5122b47",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167613",
      "rating": "5",
      "name": "Amelia Crawford",
      "text": "I’ve been living in Stonebriar for about 1 month now, and I absolutely love it!\nI worked with Julia in the office who has been amazing! She is so nice and always has an answer for my questions. Her prompt responses have been very helpful.\nOn my move in day, she started my walkthrough with me, and showed me how to submit my move in inspection. There were only a few minor things that needed touching up, and they came quickly to have them done. With great communication there as well, I can see us living here for a long time\n\nThank you Julia!",
      "date": "2026-07-28",
      "title": "false"
    },
    {
      "id": "ec_02477d0de2477d00dab898ba",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167613",
      "rating": "5",
      "name": "Cameron Davidson",
      "text": "My washing machine's fill valve malfunctioned at 8pm yesterday, leaving me with an inch or two of standing water in my laundry room within minutes. I called the emergency maintenance request line and received a call back within the minute. The emergency crew was out within the hour to extract the water and start the drying process. They were in and out within 30 minutes, very fast at what they do. The regular maintenence crew came out the next day (today) and fixed the washer completely, it is running like brand new! It was a very intense situation that could have been made worse from subpar management, but everything turned out very well due to the prompt action that the complex took.\n\nPeople tend to leave reviews only when something goes wrong or when they're unhappy, but here's a review from someone who had a totally positive experience all around despite the bad situation.\n\nThank you, Stonebriar, for making me a priority and getting the work done on time! I've been here 6 months now and this is the first thing that has needed maintenance in my 1b/1ba unit. Everything else has been perfect so far!",
      "date": "2026-05-28",
      "title": "false"
    },
    {
      "id": "ec_b4cabc4f67ffad810f17c9a5",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167613",
      "rating": "5",
      "name": "Michael McCullough",
      "text": "In 2+ years here, I've had nothing but positive experiences. I've enjoyed quick and responsive communication from helpful staff from both the office and facilities/maintenance. I don't know everyone's names but Tess and Molly and several others have been great! No plans to leave anytime soon.",
      "date": "2026-05-20",
      "title": "false"
    }
  ],
  "virtual_tours": [
    {
      "id": "ec_0ce5d95e0f7580edc1d19db8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167613",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167613/01a0b667-9da1-73ea-8669-04c2c6752a9a.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a0b667-9da1-73ea-8669-04c2c6752a9a",
        "storage_key": "property/6767906449167613/01a0b667-9da1-73ea-8669-04c2c6752a9a.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Murfield",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=kxnG4BBotZA"
    },
    {
      "id": "ec_93644c9fa58e232e62c66011",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167613",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167613/01a0b667-9614-71af-8c38-7b7b7cd8f6e8.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a0b667-9614-71af-8c38-7b7b7cd8f6e8",
        "storage_key": "property/6767906449167613/01a0b667-9614-71af-8c38-7b7b7cd8f6e8.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Pebble Beach",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=adrumA6aqqC"
    },
    {
      "id": "ec_86b7e823b36c225f9c27b5bf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167613",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167613/01a0b667-a405-755a-b4a4-724e7c74b811.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a0b667-a405-755a-b4a4-724e7c74b811",
        "storage_key": "property/6767906449167613/01a0b667-a405-755a-b4a4-724e7c74b811.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "St. Andrews",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=dpK1FGGG7xb"
    },
    {
      "id": "ec_d463c118e3e37dcb11a3e85c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167613",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167613/01a0b667-901f-707b-82cc-8dc9f285de8d.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a0b667-901f-707b-82cc-8dc9f285de8d",
        "storage_key": "property/6767906449167613/01a0b667-901f-707b-82cc-8dc9f285de8d.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Augusta",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=DMr2m2M7DCx"
    },
    {
      "id": "ec_30ff613ac87812312ea8ae96",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167613",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167613/01a0b667-a941-755c-a24b-5c87747f5bd9.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a0b667-a941-755c-a24b-5c87747f5bd9",
        "storage_key": "property/6767906449167613/01a0b667-a941-755c-a24b-5c87747f5bd9.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Pinehurst",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=hK4B7wVyYEh"
    }
  ],
  "faqs": [
    {
      "id": "custom_a6256d89-9c4c-4ce2-89b0-7fc06370941d",
      "question": "What are the qualifications for occupancy?",
      "answer": "Check our occupancy qualifications <a href=\"https://www.pricebrotherskc.com/ResidentialRentalQualifications/\">here</a>. We encourage everyone to apply, and hope to have you as a part of our community!",
      "category": "Rental Qualifications",
      "source": "custom"
    },
    {
      "id": "custom_8f1e6613-9e35-4784-8fda-584d79601855",
      "question": "What is the application fee and is it refundable?",
      "answer": "Application fees are due for each person 18 and older occupying the apartment. All application fees are nonrefundable.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_2a5f876d-5344-4162-a849-880d97991240",
      "question": "How do I apply?",
      "answer": "Click on the <a href=\"/apply-now\">Apply Now</a> button under the <a href=\"/floor-plans\">Floor Plans</a> tab of our community website.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_ff49b3d2-b623-428b-bcc7-9faf59d5d1ec",
      "question": "How can I refer a friend?",
      "answer": "If you love living here and want to refer a friend, please let our office know! We offer resident referral programs throughout the year and would love for your friends and family to join our community.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_efecef2a-6e2c-400f-9b85-ffe92228fef8",
      "question": "Are there different lease term options available?",
      "answer": "Yes, we offer various lease term options. Please <a href=\"/contact-us\">contact our office</a> for more details.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_b32f1023-5839-4538-bac9-2fa9edea00da",
      "question": "Do I need an appointment to take a tour?",
      "answer": "No appointment is necessary to tour our community during business hours; however, it is always appreciated if you call ahead to make sure we are available to provide adequate time for you to tour and ask questions. It is recommended to arrive no later than one half hour prior to closing if you would like to tour the community. Everyone over 18 years of age must have a valid photo ID to tour. Valid forms of identification are decided by Price Brothers Management Company and may include items such as: US Driver’s License, US State Photo ID, US Military Photo ID, US Visa with Photo ID upon it, US Citizenship and Immigration Services Photo ID, Passport.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_2019e3d4-873b-4b95-a993-05fae89a1643",
      "question": "Do you allow pets?",
      "answer": "Our community is happy to accept cats and dogs. Please refer to our pet section on the <a href=\"/pet-policy\">Pet Policy</a> page.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_335a1267-a2ee-43a0-99f8-14a7962b6754",
      "question": "What is a holding deposit or earnest money?",
      "answer": "A \"holding\" deposit or \"earnest money\" is another word for \"security\" deposit. Please <a href=\"/contact-us\">contact our leasing office</a> for more details.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_d238186b-a8b9-4996-9b08-d107e497d597",
      "question": "Why does your pricing include ranges?",
      "answer": "The prices will range on each floor plan depending on finishes, views, and other features inside the apartment home.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_45d386fc-0e05-4312-b23e-667ebd85b86f",
      "question": "What utilities am I responsible to pay?",
      "answer": "Our residents are responsible to pay for water, sewer, trash, pest control services, cable/internet, and electric.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_810cb20d-51f8-4dab-a1cd-aa7839bed099",
      "question": "Do you require renters insurance?",
      "answer": "All residents are required to maintain a minimum of $100,000 in liability coverage as part of their lease agreement. For more details on coverage requirements and available options, please <a href=\"/contact-us\">contact our leasing office</a>.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_b7e11e20-f261-41f8-aaaf-d181ea80f369",
      "question": "How can I pay my rent?",
      "answer": "You can pay rent by accessing your <a href=\"/resident-access\">resident online account</a>. This allows you to use a bank account or credit card to make payments.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_2dd814fc-86d6-4712-afc8-f3100eb9f4db",
      "question": "Do you offer covered parking?",
      "answer": "Yes, we offer carports and detached garages. Please <a href=\"/contact-us\">contact the office</a> for our most current pricing and availability.",
      "category": "Amenities",
      "source": "custom"
    },
    {
      "id": "custom_749485e4-ce49-4c7e-9410-27f0fed6499f",
      "question": "Do you host events at your property?",
      "answer": "Yes, we host events throughout the year with various activities to encourage community camaraderie.",
      "category": "Amenities",
      "source": "custom"
    },
    {
      "id": "custom_e981353a-c3b3-4e1f-bb46-3e8652c42bec",
      "question": "Do you accept packages on behalf of the residents?",
      "answer": "No, we do not offer this service at this time.",
      "category": "Amenities",
      "source": "custom"
    },
    {
      "id": "custom_25afb017-551b-4800-b243-f5436e3cc665",
      "question": "If something needs to be repaired in my apartment, how do I report it?",
      "answer": "You may call the office or submit work orders online by accessing your <a href=\"/resident-access\">resident account</a>. All emergency repairs should be reported by <a href=\"/contact-us\">contacting the office</a>. If the emergency is being reported after business hours, please follow the prompts to be connected to the answering service.",
      "category": "Maintenance",
      "source": "custom"
    }
  ],
  "fees": [],
  "pet_policies": [],
  "lead_collectors": [
    {
      "lead_collector_id": "01a0c9ac-45a4-74f0-8975-38ead7faa53f",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "Stonebriar Apartment Homes Property Website",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167613"
    },
    {
      "lead_collector_id": "01a0c9ac-462c-7145-ba0a-abbdfd519311",
      "lead_source": "LANDING_PAGE",
      "name": "Stonebriar Apartment Homes Landing Page",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167613"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167613",
      "source": "generator",
      "page_item_url": "in-unit-laundry-apartments-overland-park",
      "search_query": "apartments with in-unit laundry Overland Park",
      "category": "Amenity",
      "h1_title": "In-Unit Laundry Apartments in Overland Park",
      "h2_subtitle": "Discover Stonebriar's spacious homes with in-unit laundry. Enjoy Overland Park living steps from Indian Creek Trail.",
      "page_copy": "Experience the convenience of modern living at Stonebriar Apartment Homes, where each one-, two-, and three-bedroom apartment offers in-unit laundry facilities. Nestled in the heart of Overland Park, our community provides an ideal blend of comfort and practicality. Whether you're commuting via nearby I-435 or enjoying a leisurely day on the Indian Creek Trail, you'll love coming home to a place equipped with everything you need.\n\nAt Stonebriar, we believe that home should be a sanctuary. That's why we offer more than just in-unit laundry. From private balconies to vaulted ceilings, every element is designed for your ease and enjoyment. Come see why our Overland Park apartments make life simpler. Schedule a tour and discover your next home today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167613/019fc989-8e22-7167-b140-88329c783ad7.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a large L-shaped swimming pool with a hot tub and surrounding lounge chairs.",
        "public_id": "019fc989-8e22-7167-b140-88329c783ad7",
        "storage_key": "property/6767906449167613/019fc989-8e22-7167-b140-88329c783ad7.webp",
        "width": 1200,
        "height": 799
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "In-Unit Laundry Apartments in Overland Park",
      "seo_description": "Discover Stonebriar's Overland Park apartments with in-unit laundry and spacious floor plans. Schedule a tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167613",
      "source": "generator",
      "page_item_url": "pet-friendly-dog-park-apartments-johnson-county",
      "search_query": "pet-friendly apartments with dog park in Johnson County",
      "category": "Amenity",
      "h1_title": "Pet-Friendly Apartments with Dog Park",
      "h2_subtitle": "Welcome to Stonebriar's pet-friendly community in Johnson County. Enjoy our dog-friendly amenities near I-35.",
      "page_copy": "Stonebriar Apartment Homes in Johnson County is the perfect pet-friendly community for you and your furry family members. With a designated dog park onsite, your pet will have plenty of space to play and exercise. Nestled in a convenient location near I-35, our community offers a serene retreat with access to both city amenities and nature trails.\n\nOur spacious one-, two-, and three-bedroom apartments provide everything you and your pet need for comfortable living, including private balconies for fresh air relaxation. Residents can enjoy vaulted ceilings and extensive amenities, making Stonebriar a haven in the heart of Johnson County. Visit us today and see why our pet-friendly environment is so special.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167613/019fc989-8e22-7167-b140-88329c783ad7.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a large L-shaped swimming pool with a hot tub and surrounding lounge chairs.",
        "public_id": "019fc989-8e22-7167-b140-88329c783ad7",
        "storage_key": "property/6767906449167613/019fc989-8e22-7167-b140-88329c783ad7.webp",
        "width": 1200,
        "height": 799
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pet-Friendly Apartments with Dog Park",
      "seo_description": "Stonebriar in Johnson County offers pet-friendly living with a dog park. Enjoy spacious apartments and great amenities. Visit today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167613",
      "source": "generator",
      "page_item_url": "swimming-pool-apartments-near-i-435",
      "search_query": "swimming pool apartments near I-435",
      "category": "Amenity",
      "h1_title": "Swimming Pool Apartments by I-435",
      "h2_subtitle": "Relax in Stonebriar's refreshing pool. Conveniently located near I-435, enjoy easy access and modern amenities in Overland Park.",
      "page_copy": "Dive into comfort at Stonebriar Apartment Homes, where our sparkling swimming pool offers a refreshing escape just steps from your front door. Located in vibrant Overland Park, our community combines the tranquility of suburban living with the convenience of proximity to I-435, making commuting a breeze.\n\nOur one-, two-, and three-bedroom apartments come with features like private balconies, in-unit laundry, and vaulted ceilings. After a swim, explore the nearby Indian Creek Trail or unwind in your spacious home. Discover why Stonebriar is perfect for those who value relaxation and accessibility. Schedule a tour today and experience the benefits of a poolside lifestyle.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167613/019fc989-8e22-7167-b140-88329c783ad7.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a large L-shaped swimming pool with a hot tub and surrounding lounge chairs.",
        "public_id": "019fc989-8e22-7167-b140-88329c783ad7",
        "storage_key": "property/6767906449167613/019fc989-8e22-7167-b140-88329c783ad7.webp",
        "width": 1200,
        "height": 799
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Swimming Pool Apartments by I-435",
      "seo_description": "Enjoy Stonebriar's apartments with a swimming pool near I-435 in Overland Park. Discover spacious homes and great amenities. Visit us now!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167613",
      "source": "generator",
      "page_item_url": "luxury-apartments-air-conditioning-66213",
      "search_query": "luxury apartments with air conditioning 66213",
      "category": "Amenity",
      "h1_title": "Luxury Apartments with A/C in 66213",
      "h2_subtitle": "Explore Stonebriar's luxury homes offering premium amenities, including air conditioning. Nestled in Overland Park, discover comfortable living in style.",
      "page_copy": "Enjoy ultimate comfort at Stonebriar Apartment Homes, where luxury meets convenience in the 66213 area. Each of our one-, two-, and three-bedroom homes is fitted with air conditioning to ensure you stay comfortable year-round. Located in Overland Park, you'll find that our apartments offer a premium living experience tailored to your modern lifestyle.\n\nBeyond in-home amenities like air conditioning, residents benefit from community perks such as private outdoor spaces and easy access to both I-435 and I-35, making commuting seamless. With nearby trails and entertainment options, Stonebriar provides a perfect blend of elegance and convenience. Schedule a tour today to see why our luxurious homes stand out in the Overland Park area.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167613/019fc989-8e22-7167-b140-88329c783ad7.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a large L-shaped swimming pool with a hot tub and surrounding lounge chairs.",
        "public_id": "019fc989-8e22-7167-b140-88329c783ad7",
        "storage_key": "property/6767906449167613/019fc989-8e22-7167-b140-88329c783ad7.webp",
        "width": 1200,
        "height": 799
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury Apartments with A/C in 66213",
      "seo_description": "Discover luxury living with air conditioning at Stonebriar Apartments in Overland Park 66213. Enjoy spacious homes and top amenities. Schedule a tour now!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167613",
      "source": "generator",
      "page_item_url": "dishwasher-apartments-near-indian-creek-trail",
      "search_query": "dishwasher apartments near Indian Creek Trail",
      "category": "Amenity",
      "h1_title": "Dishwasher Apartments by Indian Creek Trail",
      "h2_subtitle": "Stonebriar offers modern apartments equipped with dishwashers. Enjoy easy access to Indian Creek Trail for relaxation and recreation.",
      "page_copy": "Stonebriar Apartment Homes presents an ideal living space for those seeking modern conveniences and natural beauty. Each apartment comes equipped with an efficient dishwasher, ensuring hassle-free living. Situated near the picturesque Indian Creek Trail, our community offers residents a perfect blend of comfort and adventure.\n\nOur one-, two-, and three-bedroom floor plans are designed with you in mind, offering private balconies and open spaces. Take advantage of nearby trail access for leisurely walks or bike rides. Located in Overland Park, our apartments also boast excellent connectivity with key highways like I-435, making daily commutes seamless. Don't miss the opportunity to live in a community that embraces both practicality and beauty.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167613/019fc989-8e22-7167-b140-88329c783ad7.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a large L-shaped swimming pool with a hot tub and surrounding lounge chairs.",
        "public_id": "019fc989-8e22-7167-b140-88329c783ad7",
        "storage_key": "property/6767906449167613/019fc989-8e22-7167-b140-88329c783ad7.webp",
        "width": 1200,
        "height": 799
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Dishwasher Apartments by Indian Creek Trail",
      "seo_description": "Find apartments with dishwashers near Indian Creek Trail at Stonebriar. Enjoy modern amenities and nature access. Explore today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167613",
      "source": "generator",
      "page_item_url": "1-bedroom-overland-park-ks",
      "search_query": "1 bedroom Overland Park KS",
      "category": "Floorplan",
      "h1_title": "1 Bedroom Apartments in Overland Park, KS",
      "h2_subtitle": "Explore stylish 1 bedroom apartments at Stonebriar. Located in Overland Park, KS, our homes offer comfort with modern conveniences.",
      "page_copy": "Discover the perfect 1 bedroom apartment at Stonebriar Apartment Homes in Overland Park, KS. Our thoughtfully designed spaces combine functionality with style, featuring in-home laundry, private patios or balconies, and modern aesthetics. Nestled in a vibrant neighborhood, Stonebriar provides easy access to local dining, shopping, and the peaceful Indian Creek Trail.\n\nOur community is designed with modern lifestyles in mind, offering proximity to major highways such as I-435 and I-35, making commuting a breeze. Whether you enjoy relaxing in your spacious home, taking peaceful strolls, or exploring nearby attractions, our 1 bedroom apartments offer the perfect retreat. Schedule a tour today and see why Stonebriar is a top choice in Overland Park.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167613/019fc989-8e22-7167-b140-88329c783ad7.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a large L-shaped swimming pool with a hot tub and surrounding lounge chairs.",
        "public_id": "019fc989-8e22-7167-b140-88329c783ad7",
        "storage_key": "property/6767906449167613/019fc989-8e22-7167-b140-88329c783ad7.webp",
        "width": 1200,
        "height": 799
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "1 Bedroom Apartments in Overland Park, KS",
      "seo_description": "Find stylish 1 bedroom apartments in Overland Park, KS at Stonebriar. Enjoy spacious layouts and modern amenities. Schedule a visit today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167613",
      "source": "generator",
      "page_item_url": "2-bedroom-apartments-johnson-county",
      "search_query": "2 bedroom apartments Johnson County",
      "category": "Floorplan",
      "h1_title": "2 Bedroom Apartments in Johnson County",
      "h2_subtitle": "Discover stylish 2 bedroom apartments at Stonebriar. Located in Johnson County, enjoy spacious living with modern amenities and community perks.",
      "page_copy": "Stonebriar Apartment Homes offers beautifully designed 2 bedroom apartments ideally situated in Johnson County. Our spacious floor plans are designed with contemporary flair and include features such as in-home laundry and private outdoor spaces. Located conveniently in Overland Park, our community ensures easy access to the best of both suburban tranquility and urban excitement.\n\nResidents of Stonebriar enjoy close proximity to major highways like I-435 and I-35, facilitating easy commuting and connectivity throughout Johnson County and beyond. Our location near Indian Creek Trail offers an escape into nature, while various dining and shopping options ensure all you need is within reach. Visit Stonebriar today and discover why our 2 bedroom apartments stand out in Johnson County.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167613/019fc989-8e22-7167-b140-88329c783ad7.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a large L-shaped swimming pool with a hot tub and surrounding lounge chairs.",
        "public_id": "019fc989-8e22-7167-b140-88329c783ad7",
        "storage_key": "property/6767906449167613/019fc989-8e22-7167-b140-88329c783ad7.webp",
        "width": 1200,
        "height": 799
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "2 Bedroom Apartments in Johnson County",
      "seo_description": "Explore 2 bedroom apartments in Johnson County at Stonebriar. Enjoy modern living with top amenities. Schedule your tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167613",
      "source": "generator",
      "page_item_url": "3-bedroom-floorplans-near-i435",
      "search_query": "3 bedroom floorplans near I-435",
      "category": "Floorplan",
      "h1_title": "3 Bedroom Floorplans Near I-435",
      "h2_subtitle": "Stonebriar offers spacious 3 bedroom floorplans near I-435. Experience comfortable living with easy highway access and top amenities.",
      "page_copy": "At Stonebriar Apartment Homes, we present thoughtfully designed 3 bedroom floorplans that perfectly accommodate families and roommates alike. Situated near I-435 in Overland Park, our location ensures effortless commuting to nearby cities and attractions, making it a great choice for those seeking convenience paired with space.\n\nOur expansive floorplans come with modern touches like in-home laundry and private outdoor areas, creating a comfortable and stylish living environment. Residents can enjoy community perks and the proximity to Indian Creek Trail, perfect for weekend adventures and outdoor enjoyment. Discover the ideal blend of comfort and connectivity by scheduling a tour at Stonebriar Apartment Homes today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167613/019fc989-8e22-7167-b140-88329c783ad7.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a large L-shaped swimming pool with a hot tub and surrounding lounge chairs.",
        "public_id": "019fc989-8e22-7167-b140-88329c783ad7",
        "storage_key": "property/6767906449167613/019fc989-8e22-7167-b140-88329c783ad7.webp",
        "width": 1200,
        "height": 799
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "3 Bedroom Floorplans Near I-435",
      "seo_description": "Find spacious 3 bedroom floorplans near I-435 at Stonebriar. Experience convenient living with modern amenities. Visit today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167613",
      "source": "generator",
      "page_item_url": "apartments-near-pleasant-ridge-elementary-overland-park",
      "search_query": "apartments near Pleasant Ridge Elementary School Overland Park",
      "category": "School",
      "h1_title": "Apartments Near Pleasant Ridge Elementary, Overland Park",
      "h2_subtitle": "Explore family-friendly apartments near Pleasant Ridge Elementary School. Stonebriar offers convenience and comfort in Overland Park.",
      "page_copy": "Stonebriar Apartment Homes offers an ideal location for families seeking apartments near Pleasant Ridge Elementary School in Overland Park. Our community provides spacious, family-friendly floor plans with in-home laundry and private outdoor areas, ensuring both comfort and convenience.\n\nSituated in a welcoming neighborhood, Stonebriar connects you to quality education and vibrant community life. With highways I-435 and I-35 nearby, ease of travel around Overland Park is guaranteed. Residents also enjoy proximity to local parks and trails, like Indian Creek Trail, providing ample opportunities for recreation and relaxation. Visit Stonebriar today to discover why our community is perfect for families.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167613/019fc989-8e22-7167-b140-88329c783ad7.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a large L-shaped swimming pool with a hot tub and surrounding lounge chairs.",
        "public_id": "019fc989-8e22-7167-b140-88329c783ad7",
        "storage_key": "property/6767906449167613/019fc989-8e22-7167-b140-88329c783ad7.webp",
        "width": 1200,
        "height": 799
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Pleasant Ridge Elementary, Overland Park",
      "seo_description": "Find family-friendly apartments near Pleasant Ridge Elementary in Overland Park at Stonebriar. Enjoy spacious living in a prime location. Visit today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167613",
      "source": "generator",
      "page_item_url": "stonebriar-apartments-by-california-trail-middle-school",
      "search_query": "Stonebriar apartments by California Trail Middle School",
      "category": "School",
      "h1_title": "Stonebriar Apartments by California Trail Middle School",
      "h2_subtitle": "Locate Stonebriar Apartments conveniently near California Trail Middle School. Enjoy both modern living and educational accessibility in Overland Park.",
      "page_copy": "Stonebriar Apartment Homes provides an ideal living location just a short distance from California Trail Middle School. Offering a variety of spacious floor plans, including one-, two-, and three-bedroom options, Stonebriar combines modern amenities with a prime Overland Park location.\n\nFamilies appreciate the convenience of being near California Trail Middle School while enjoying Stonebriar's community perks, such as private balconies and patios, as well as access to recreational areas like Indian Creek Trail. Situated near major highways like I-435, Stonebriar makes commuting and accessing local attractions easy. Choose Stonebriar for a seamless blend of education and lifestyle.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167613/019fc989-8e22-7167-b140-88329c783ad7.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a large L-shaped swimming pool with a hot tub and surrounding lounge chairs.",
        "public_id": "019fc989-8e22-7167-b140-88329c783ad7",
        "storage_key": "property/6767906449167613/019fc989-8e22-7167-b140-88329c783ad7.webp",
        "width": 1200,
        "height": 799
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Stonebriar Apartments by California Trail Middle School",
      "seo_description": "Discover Stonebriar Apartments near California Trail Middle School. Enjoy easy access to education and modern living. Schedule a tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167613",
      "source": "generator",
      "page_item_url": "olathe-east-high-school-apartments-johnson-county",
      "search_query": "Olathe East High School apartments in Johnson County",
      "category": "School",
      "h1_title": "Apartments Near Olathe East High School",
      "h2_subtitle": "Discover apartment living near Olathe East High School in Johnson County at Stonebriar. Enjoy convenience and comfort in a prime location.",
      "page_copy": "Located in the heart of Johnson County, Stonebriar Apartment Homes offers the perfect setting for those looking for apartments near Olathe East High School. Our community features spacious floor plans that cater to the needs of families and professionals seeking both comfort and convenience.\n\nStonebriar is well-positioned with easy access to I-435 and I-35, making commuting around Overland Park and neighboring areas a breeze. With amenities like private outdoor spaces and proximity to Indian Creek Trail, Stonebriar provides an optimal blend of suburban tranquility and city accessibility. Experience living near premier educational facilities by calling Stonebriar home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167613/019fc989-8e22-7167-b140-88329c783ad7.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a large L-shaped swimming pool with a hot tub and surrounding lounge chairs.",
        "public_id": "019fc989-8e22-7167-b140-88329c783ad7",
        "storage_key": "property/6767906449167613/019fc989-8e22-7167-b140-88329c783ad7.webp",
        "width": 1200,
        "height": 799
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Olathe East High School",
      "seo_description": "Find spacious apartments near Olathe East High School in Johnson County at Stonebriar. Enjoy modern comforts and educational proximity. Schedule your visit!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167613",
      "source": "generator",
      "page_item_url": "university-kansas-edwards-campus-nearby-apartments",
      "search_query": "University of Kansas Edwards Campus nearby apartments",
      "category": "School",
      "h1_title": "Apartments Near University of Kansas Edwards Campus",
      "h2_subtitle": "Stonebriar is ideally located near the University of Kansas Edwards Campus. Enjoy modern living in a convenient Overland Park location.",
      "page_copy": "Stonebriar Apartment Homes offers the perfect place to reside just minutes from the University of Kansas Edwards Campus. Our spacious floor plans provide comfortable living arrangements, ideal for students, professionals, and families seeking convenience without compromising on comfort.\n\nLocated in Overland Park’s thriving community, Stonebriar allows easy access to the vibrant campus life while also offering amenities like private patios or balconies and vaulted ceilings in select units. The proximity to major highways I-435 and I-35 ensures seamless travel throughout Johnson County and beyond. Discover the perfect blend of study and leisure at Stonebriar.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167613/019fc989-8e22-7167-b140-88329c783ad7.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a large L-shaped swimming pool with a hot tub and surrounding lounge chairs.",
        "public_id": "019fc989-8e22-7167-b140-88329c783ad7",
        "storage_key": "property/6767906449167613/019fc989-8e22-7167-b140-88329c783ad7.webp",
        "width": 1200,
        "height": 799
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near University of Kansas Edwards Campus",
      "seo_description": "Explore Stonebriar Apartments near the University of Kansas Edwards Campus. Enjoy modern amenities and prime location in Overland Park.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167613",
      "source": "generator",
      "page_item_url": "apartments-close-johnson-county-community-college",
      "search_query": "apartments close to Johnson County Community College Overland Park",
      "category": "School",
      "h1_title": "Apartments Near Johnson County Community College",
      "h2_subtitle": "Find ideal living at Stonebriar, close to Johnson County Community College in Overland Park. Embrace convenience and modern amenities.",
      "page_copy": "Stonebriar Apartment Homes is the perfect choice for those seeking apartments close to Johnson County Community College in Overland Park. Our community offers diverse one-, two-, and three-bedroom floor plans that cater to students and professionals alike, ensuring comfort and accessibility.\n\nLiving at Stonebriar means enjoying amenities such as private balconies, in-home laundry, and easy access to Indian Creek Trail. Located near major routes like I-435 and I-35, Stonebriar provides excellent connectivity to Overland Park and nearby areas, making commuting easy and stress-free. Experience the ideal blend of academics and lifestyle at Stonebriar Apartments.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167613/019fc989-8e22-7167-b140-88329c783ad7.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a large L-shaped swimming pool with a hot tub and surrounding lounge chairs.",
        "public_id": "019fc989-8e22-7167-b140-88329c783ad7",
        "storage_key": "property/6767906449167613/019fc989-8e22-7167-b140-88329c783ad7.webp",
        "width": 1200,
        "height": 799
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Johnson County Community College",
      "seo_description": "Discover Stonebriar Apartments close to Johnson County Community College. Enjoy modern living in Overland Park with convenient access.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167613",
      "source": "generator",
      "page_item_url": "stonebriar-apartments-near-overland-trail-middle-school",
      "search_query": "Stonebriar apartments near Overland Trail Middle School 66213",
      "category": "School",
      "h1_title": "Stonebriar Apartments Near Overland Trail Middle",
      "h2_subtitle": "Located near Overland Trail Middle School, Stonebriar Apartments provide comfort and convenience for families in the 66213 area.",
      "page_copy": "Stonebriar Apartment Homes boasts a prime location for families looking to reside near Overland Trail Middle School in the 66213 zip code. Our community offers spacious one-, two-, and three-bedroom floor plans, designed to provide ample living space and modern conveniences.\n\nEnjoy the perks of living in Stonebriar, with amenities including in-home laundry and private outdoor spaces, perfect for unwinding after a day of school or work. Situated with easy access to I-435 and I-35, our apartments ensure you are well-connected within Overland Park and Johnson County. Experience the perfect family-friendly living environment at Stonebriar.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167613/019fc989-8e22-7167-b140-88329c783ad7.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a large L-shaped swimming pool with a hot tub and surrounding lounge chairs.",
        "public_id": "019fc989-8e22-7167-b140-88329c783ad7",
        "storage_key": "property/6767906449167613/019fc989-8e22-7167-b140-88329c783ad7.webp",
        "width": 1200,
        "height": 799
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Stonebriar Apartments Near Overland Trail Middle",
      "seo_description": "Find family-friendly living at Stonebriar, near Overland Trail Middle School in the 66213 area. Spacious floor plans and convenient access await!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167613",
      "source": "generator",
      "page_item_url": "apartments-near-overland-park-regional-medical-center",
      "search_query": "apartments near overland park regional medical center",
      "category": "Hospital",
      "h1_title": "Apartments Near Overland Park Regional Medical Center",
      "h2_subtitle": "Stonebriar Apartments offer comfort and convenience close to Overland Park Regional Medical Center. Perfect for healthcare professionals and families.",
      "page_copy": "Stonebriar Apartment Homes is an excellent choice for those seeking comfortable living close to Overland Park Regional Medical Center. With spacious one-, two-, and three-bedroom floor plans, our community caters to the needs of healthcare professionals and families alike, ensuring a convenient and stress-free lifestyle.\n\nResidents enjoy modern amenities such as in-home laundry and private outdoor spaces, ideal for relaxation after a hectic day at the hospital. Located a short drive from I-435 and I-35, Stonebriar ensures easy commutes not just to the medical center but throughout Overland Park and Johnson County. Embrace a balanced life at Stonebriar Apartments.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167613/019fc989-8e22-7167-b140-88329c783ad7.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a large L-shaped swimming pool with a hot tub and surrounding lounge chairs.",
        "public_id": "019fc989-8e22-7167-b140-88329c783ad7",
        "storage_key": "property/6767906449167613/019fc989-8e22-7167-b140-88329c783ad7.webp",
        "width": 1200,
        "height": 799
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Overland Park Regional Medical Center",
      "seo_description": "Explore Stonebriar Apartments near Overland Park Regional Medical Center. Experience comfortable living perfect for healthcare professionals and families.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167613",
      "source": "generator",
      "page_item_url": "stonebriar-apartments-close-to-childrens-mercy-kansas",
      "search_query": "stonebriar apartments close to children's mercy kansas",
      "category": "Hospital",
      "h1_title": "Stonebriar Apartments Near Children's Mercy KS",
      "h2_subtitle": "Discover convenient living at Stonebriar, close to Children's Mercy Kansas in Overland Park. Perfect for healthcare staff and families.",
      "page_copy": "For those seeking apartments near Children's Mercy Kansas, Stonebriar Apartment Homes offers the perfect blend of convenience and comfort in Overland Park. Our spacious one-, two-, and three-bedroom apartments are ideal for healthcare professionals and families, providing easy access to the medical center.\n\nAt Stonebriar, enjoy in-home laundry, private balconies, and a short commute thanks to nearby I-435 and I-35. Our community also features direct access to Indian Creek Trail, enhancing both relaxation and recreation. Choose Stonebriar for a balanced lifestyle close to Children's Mercy Kansas.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167613/019fc989-8e22-7167-b140-88329c783ad7.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a large L-shaped swimming pool with a hot tub and surrounding lounge chairs.",
        "public_id": "019fc989-8e22-7167-b140-88329c783ad7",
        "storage_key": "property/6767906449167613/019fc989-8e22-7167-b140-88329c783ad7.webp",
        "width": 1200,
        "height": 799
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Stonebriar Apartments Near Children's Mercy Kansas",
      "seo_description": "Live at Stonebriar Apartments, close to Children's Mercy Kansas. Ideal for healthcare teams and families seeking convenience in Overland Park.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167613",
      "source": "generator",
      "page_item_url": "apartments-near-overland-park-arboretum-botanical-gardens",
      "search_query": "apartments near Overland Park Arboretum & Botanical Gardens",
      "category": "Park",
      "h1_title": "Apartments Near Overland Park Arboretum & Gardens",
      "h2_subtitle": "Stonebriar Apartments offer serene living near the Overland Park Arboretum & Botanical Gardens. Perfect for nature lovers and families.",
      "page_copy": "Stonebriar Apartment Homes is the perfect choice for those looking for tranquil living near the Overland Park Arboretum & Botanical Gardens. Offering spacious one-, two-, and three-bedroom apartments, our community is ideally situated for nature enthusiasts and families who enjoy the beauty of the great outdoors.\n\nResidents of Stonebriar can enjoy modern amenities, including in-home laundry and private outdoor spaces, enhancing their connection to nature. Convenient access to I-435 and I-35 ensures that you are never too far from the vibrant offerings of Overland Park. Discover serene living at Stonebriar Apartments, close to the Arboretum and beyond.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167613/019fc989-8e22-7167-b140-88329c783ad7.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a large L-shaped swimming pool with a hot tub and surrounding lounge chairs.",
        "public_id": "019fc989-8e22-7167-b140-88329c783ad7",
        "storage_key": "property/6767906449167613/019fc989-8e22-7167-b140-88329c783ad7.webp",
        "width": 1200,
        "height": 799
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Overland Park Arboretum & Gardens",
      "seo_description": "Explore Stonebriar Apartments, near Overland Park Arboretum & Botanical Gardens. Ideal for nature lovers seeking tranquility and convenience in Overland Park.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167613",
      "source": "generator",
      "page_item_url": "quivira-park-nearby-apartment-homes-ks",
      "search_query": "Quivira Park nearby apartment homes KS",
      "category": "Park",
      "h1_title": "Quivira Park Nearby Apartment Homes in KS",
      "h2_subtitle": "Discover Stonebriar Apartments, conveniently located near Quivira Park in KS. Ideal for active lifestyles and family living.",
      "page_copy": "Stonebriar Apartment Homes offers a harmonious blend of modern living and outdoor enjoyment, located near the scenic Quivira Park in KS. Perfect for families and individuals who appreciate active lifestyles, our one-, two-, and three-bedroom layouts provide spacious and comfortable living options.\n\nResidents benefit from amenities such as in-home laundry, private patios or balconies, and direct access to walking trails including Indian Creek Trail. Our prime location provides easy access to I-435 and I-35, making all of Overland Park and surrounding areas conveniently reachable. Experience quality living at Stonebriar Apartments, where Quivira Park is just a stone's throw away.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167613/019fc989-8e22-7167-b140-88329c783ad7.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a large L-shaped swimming pool with a hot tub and surrounding lounge chairs.",
        "public_id": "019fc989-8e22-7167-b140-88329c783ad7",
        "storage_key": "property/6767906449167613/019fc989-8e22-7167-b140-88329c783ad7.webp",
        "width": 1200,
        "height": 799
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Quivira Park Nearby Apartment Homes in KS",
      "seo_description": "Find Stonebriar Apartments near Quivira Park, KS. Perfect for active families and individuals seeking spacious living with outdoor access.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167613",
      "source": "generator",
      "page_item_url": "apartments-close-to-thomas-stoll-memorial-park-overland-park",
      "search_query": "apartments close to Thomas S. Stoll Memorial Park Overland Park",
      "category": "Park",
      "h1_title": "Apartments Close to Thomas S. Stoll Park",
      "h2_subtitle": "Enjoy life at Stonebriar, just moments from Thomas S. Stoll Memorial Park in Overland Park. Ideal for park lovers and families.",
      "page_copy": "Stonebriar Apartment Homes offers the perfect balance of city living and green spaces, located close to Thomas S. Stoll Memorial Park in Overland Park. Our one-, two-, and three-bedroom apartments provide ample space and modern amenities like in-home laundry that cater to individuals and families prioritizing comfort and convenience.\n\nResidents at Stonebriar can take advantage of private balconies or patios, while enjoying the ease of access to I-435 and I-35, ensuring quick commutes. The charming Thomas S. Stoll Memorial Park nearby offers a peaceful escape with recreational areas ideal for leisurely afternoons. Come home to Stonebriar, where lush parkland meets urban convenience.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167613/019fc989-8e22-7167-b140-88329c783ad7.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a large L-shaped swimming pool with a hot tub and surrounding lounge chairs.",
        "public_id": "019fc989-8e22-7167-b140-88329c783ad7",
        "storage_key": "property/6767906449167613/019fc989-8e22-7167-b140-88329c783ad7.webp",
        "width": 1200,
        "height": 799
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Thomas S. Stoll Park Overland Park",
      "seo_description": "Live at Stonebriar Apartments, near Thomas S. Stoll Memorial Park in Overland Park. Ideal living for families and park enthusiasts.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167613",
      "source": "generator",
      "page_item_url": "nall-hills-park-adjacent-apartments-outlying-johnson-county",
      "search_query": "Nall Hills Park adjacent apartments in Outlying Johnson County",
      "category": "Park",
      "h1_title": "Nall Hills Park Adjacent Apartments in Johnson County",
      "h2_subtitle": "Discover Stonebriar Apartments, adjacent to Nall Hills Park in Outlying Johnson County. Perfect for outdoor enthusiasts and families.",
      "page_copy": "Stonebriar Apartment Homes provides a perfect retreat for those who love being close to nature, situated adjacent to Nall Hills Park in Outlying Johnson County. Our spacious one-, two-, and three-bedroom floor plans offer ideal settings for modern living, complete with in-home laundry and private outdoor spaces.\n\nNestled in Johnson County, our community is designed for those who want easy access to green spaces without sacrificing urban convenience. With proximity to I-435 and I-35, commuting is a breeze, while amenities like vaulted ceilings add a touch of luxury. Experience the best of both worlds at Stonebriar, where Nall Hills Park is just steps away.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167613/019fc989-8e22-7167-b140-88329c783ad7.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a large L-shaped swimming pool with a hot tub and surrounding lounge chairs.",
        "public_id": "019fc989-8e22-7167-b140-88329c783ad7",
        "storage_key": "property/6767906449167613/019fc989-8e22-7167-b140-88329c783ad7.webp",
        "width": 1200,
        "height": 799
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Nall Hills Park Adjacent Apartments Johnson County",
      "seo_description": "Experience Stonebriar Apartments near Nall Hills Park in Outlying Johnson County. Ideal for those seeking nature and convenience.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167613",
      "source": "generator",
      "page_item_url": "roe-park-accessible-apartments-johnson-county",
      "search_query": "Roe Park accessible apartments in Johnson County",
      "category": "Park",
      "h1_title": "Roe Park Accessible Apartments in Johnson County",
      "h2_subtitle": "Discover convenient living at Stonebriar Apartments, accessible to Roe Park in Johnson County. Perfect for families and active lifestyles.",
      "page_copy": "Experience the comfort and convenience of Stonebriar Apartment Homes, accessible to the lush landscapes of Roe Park in Johnson County. Our one-, two-, and three-bedroom apartments offer modern amenities, including in-home laundry and private balconies or patios, ideal for those who value comfort and connectivity.\n\nStonebriar offers direct access to major highways like I-435 and I-35, ensuring easy commutes throughout Overland Park and beyond. Enjoy nearby recreational options at Roe Park, making it perfect for active individuals or families. Choose Stonebriar Apartments for a balanced lifestyle of accessibility and natural beauty.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167613/019fc989-8e22-7167-b140-88329c783ad7.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a large L-shaped swimming pool with a hot tub and surrounding lounge chairs.",
        "public_id": "019fc989-8e22-7167-b140-88329c783ad7",
        "storage_key": "property/6767906449167613/019fc989-8e22-7167-b140-88329c783ad7.webp",
        "width": 1200,
        "height": 799
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Roe Park Accessible Apartments Johnson County",
      "seo_description": "Live at Stonebriar Apartments, accessible to Roe Park in Johnson County. Perfect for those seeking comfortable living and easy park access.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167613",
      "source": "generator",
      "page_item_url": "apartments-near-south-lake-park-66213",
      "search_query": "apartments near South Lake Park 66213",
      "category": "Park",
      "h1_title": "Apartments Near South Lake Park in 66213",
      "h2_subtitle": "Stonebriar Apartments offers a convenient location near South Lake Park in the 66213 area. Ideal for those seeking comfort and nature.",
      "page_copy": "Stonebriar Apartment Homes offers an unparalleled living experience near South Lake Park in the bustling 66213 zip code. Our spacious one-, two-, and three-bedroom floor plans are designed for comfort, featuring in-home laundry and the luxury of private outdoor spaces.\n\nSituated conveniently in Overland Park, residents enjoy easy access to I-435 and I-35, facilitating smooth commutes while remaining close to nature. Enjoy the peace and tranquility of South Lake Park just minutes away. Trust Stonebriar Apartment Homes for a lifestyle that perfectly melds convenience with the natural beauty of the area.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167613/019fc989-8e22-7167-b140-88329c783ad7.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a large L-shaped swimming pool with a hot tub and surrounding lounge chairs.",
        "public_id": "019fc989-8e22-7167-b140-88329c783ad7",
        "storage_key": "property/6767906449167613/019fc989-8e22-7167-b140-88329c783ad7.webp",
        "width": 1200,
        "height": 799
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near South Lake Park in 66213",
      "seo_description": "Discover Stonebriar Apartments, near South Lake Park in the 66213 area. Perfect for those who love convenience and natural surroundings.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167613",
      "source": "generator",
      "page_item_url": "leawood-city-park-close-apartments-overland-park",
      "search_query": "Leawood City Park close apartments Overland Park",
      "category": "Park",
      "h1_title": "Apartments Close to Leawood City Park",
      "h2_subtitle": "Stonebriar Apartments in Overland Park offers proximity to Leawood City Park. Ideal for those who enjoy outdoor activities and urban convenience.",
      "page_copy": "Located in the heart of Overland Park, Stonebriar Apartment Homes is close to Leawood City Park, offering a perfect blend of city convenience and natural beauty. Our luxurious one-, two-, and three-bedroom apartments feature in-home laundry and private patios or balconies, making them a top choice for discerning residents.\n\nEnjoy seamless access to major roads like I-435 and I-35, ensuring swift commutes, while Leawood City Park is just a short drive away for weekend relaxation or daily exercise. Choose Stonebriar Apartments for a prime location that captures the essence of urban and suburban lifestyle harmoniously.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167613/019fc989-8e22-7167-b140-88329c783ad7.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a large L-shaped swimming pool with a hot tub and surrounding lounge chairs.",
        "public_id": "019fc989-8e22-7167-b140-88329c783ad7",
        "storage_key": "property/6767906449167613/019fc989-8e22-7167-b140-88329c783ad7.webp",
        "width": 1200,
        "height": 799
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Leawood City Park Close Apartments",
      "seo_description": "Stonebriar Apartments in Overland Park is close to Leawood City Park, combining urban living with easy access to nature.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167613",
      "source": "generator",
      "page_item_url": "apartments-near-kansas-city-international-airport",
      "search_query": "apartments near kansas city international airport overland park",
      "category": "Transit",
      "h1_title": "Apartments Near Kansas City International Airport",
      "h2_subtitle": "Stonebriar Apartments in Overland Park offers proximity to Kansas City International Airport, blending convenience with upscale living.",
      "page_copy": "Stonebriar Apartment Homes in Overland Park provides the perfect spot for those seeking apartments near Kansas City International Airport. Our spacious one-, two-, and three-bedroom layouts are thoughtfully designed, featuring in-home laundry and private outdoor spaces to elevate everyday living.\n\nSituated within easy access to major highways I-435 and I-35, our location offers seamless travel to the airport, ideal for frequent flyers or aviation professionals. Enjoy the nearby amenities, including recreational opportunities and the vibrant community of Overland Park. Choose Stonebriar for a convenient and comfortable lifestyle.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167613/019fc989-8e22-7167-b140-88329c783ad7.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a large L-shaped swimming pool with a hot tub and surrounding lounge chairs.",
        "public_id": "019fc989-8e22-7167-b140-88329c783ad7",
        "storage_key": "property/6767906449167613/019fc989-8e22-7167-b140-88329c783ad7.webp",
        "width": 1200,
        "height": 799
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Kansas City International Airport",
      "seo_description": "Find convenience with Stonebriar Apartments in Overland Park, near Kansas City International Airport, perfect for frequent travelers.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "bobbi@repli360.com"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "12701962296"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-PJTKPFVQ"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "Batch 7"
    },
    {
      "ID": "custom_vibesites_theme",
      "type": "STRING",
      "value": "Preferred"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_rentcafe_chatbot",
      "type": "STRING",
      "value": "<script type=\"text/javascript\" src=\"//webchat.omni.cafe/webchatjs/813b9680-d4fb-4243-afbe-b5f6ba1f38d4/app.js?nocache=1&gaTracking=G-JJ1X717J5X&buttonbgcolor=54585a&buttontextcolor=ffffff&chatheader=0&embed=false\"></script>"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_self_guided_tour_url",
      "type": "STRING",
      "value": "https://homes.rently.com/apartments-for-rent/Stonebriar/61045"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "913-382-7502"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6InRWcXFwR2N1TjRnbEF2eE1TQlBZaGc9PSIsInZhbHVlIjoiVUUzOVhXL3JEcFpnKzhUMks4a3ZlZz09IiwibWFjIjoiYWI4ODY4NGM1NjcxOTZkN2IwMWIwMDI2ZGJmMDE0MmE2NWFhMGNmNGIzODNiYjlmZjIxZTBhZWIxNTQ4NzRiOSJ9"
    }
  ],
  "custom_csm": "bobbi@repli360.com",
  "custom_repli_id": "12701962296",
  "custom_google_gtm_id": "GTM-PJTKPFVQ",
  "custom_rollout_phase": "Batch 7",
  "custom_vibesites_theme": "Preferred",
  "custom_ads_subscription": "essential",
  "custom_rentcafe_chatbot": "<script type=\"text/javascript\" src=\"//webchat.omni.cafe/webchatjs/813b9680-d4fb-4243-afbe-b5f6ba1f38d4/app.js?nocache=1&gaTracking=G-JJ1X717J5X&buttonbgcolor=54585a&buttontextcolor=ffffff&chatheader=0&embed=false\"></script>",
  "custom_seo_subscription": "essential",
  "custom_social_subscription": "none",
  "custom_self_guided_tour_url": "https://homes.rently.com/apartments-for-rent/Stonebriar/61045",
  "custom_website_subscription": "turnkey",
  "custom_ppc_tracking_phone_number": "913-382-7502",
  "custom_apartmentsync_javascript_id": "eyJpdiI6InRWcXFwR2N1TjRnbEF2eE1TQlBZaGc9PSIsInZhbHVlIjoiVUUzOVhXL3JEcFpnKzhUMks4a3ZlZz09IiwibWFjIjoiYWI4ODY4NGM1NjcxOTZkN2IwMWIwMDI2ZGJmMDE0MmE2NWFhMGNmNGIzODNiYjlmZjIxZTBhZWIxNTQ4NzRiOSJ9",
  "custom_audioeye_site_id": "e29f4b92-4f7c-4005-8b8a-dd1224955de2",
  "custom_audioeye_site_hash": "622abacd11d87d905439b663adbc3040"
};

export const generatedAt = '2026-11-03T22:56:56.669Z';
